<app-loader *ngIf="isLoading"></app-loader>

<div class="container-fluid px-0">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <app-main-heading>
        <span title>{{ "SIDEBAR.MANAGEDEVICES" | translate }}</span>
      </app-main-heading>
    </div>
    <div class="d-flex align-items-center justify-content-end mb-0 ms-auto">
      <label class="view-devices fw-semibold"> {{ "MANAGEDEVICE.VIEWDEVICESOF" | translate }}</label>
      <select class="form-select w-auto me-3" [(ngModel)]="selectedUserId" (ngModelChange)="onUserSelectionChange()">
        <option [ngValue]="null"> {{ "MANAGEDEVICE.ALLUSERS" | translate }}</option>
        <option *ngFor="let user of dropdownUsers" [ngValue]="user.id">
          {{ user.name }}
        </option>
      </select>
    </div>

    <div *ngIf="getMyDeviceData?.length != 0">
      <button type="button" class="bg-orgclr submit-btn shadow-none" (click)="goToAddDevice()">
        {{ "MANAGEDEVICE.ADDDEVICE" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <div class="mng-device-tabs">
      <div *ngIf="openMyDeviceContent" class="tab-pane fade show active" id="tabs-home" role="tabpanel"
        aria-labelledby="tabs-home-tab">
        <div class="row bg-white mt-3 mb-5 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
          *ngIf="getMyDeviceData?.length === 0">
          <div class="col-md-12">
            <div class="nodatafounddiv">
              <img [src]="'IMAGES.NORECORDFOUNDIMG' | translate" class="img-fluid" alt="" />
              <h1 class="mt-4">
                <app-main-heading>
                  <span title>{{
                    "MANAGEDEVICE.NODEVICEFOUND" | translate
                    }}</span>
                </app-main-heading>
              </h1>
              <button type="button" class="bg-orgclr w-auto submit-btn shadow-none" (click)="goToAddDevice()">
                {{ "MANAGEDEVICE.ADDDEVICE" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="mx-auto w-100 relative d-none d-md-block" *ngIf="getMyDeviceData?.length != 0">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="d-flex mt-3 mb-3">
                <div class="col-3">
                  <nav id="">
                    <div
                      class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column px-0 d-flex flex-wrap">
                      <ul class="flex-column min-w-100 d-flex list-unstyled me-3" id="pills-tabVertical">
                        <li *ngFor="let item of getMyDeviceData; let i = index" (click)="selectedIndex(i, item)"
                          class="align-items-center cursor-pointer bg-white" [ngClass]="
                            selectedI === i
                              ? 'q-vertical-text-user-selected'
                              : 'q-vertical-text-user'
                          ">
                          <div class="device-content" [class.with-banner]="item?.expiringStatus === 'LICENSE_EXPIRED'">
                            <tab-title-inline>
                              <span title1>

                                <div class="d-flex align-items-start">
                                  <!-- Icon column -->
                                  <div class="d-flex align-items-center justify-content-center"
                                    style="min-width: 40px; height: 40px;">
                                    <img *ngIf="item?.deviceType == 'SYSTEM'"
                                      [src]="'MANAGEDEVICE.LAPTOPSM' | translate" alt="" height="35px" width="35px" />

                                    <img *ngIf="item?.deviceType == 'MOBILE'" src="./assets/images/MobileIcon.svg"
                                      alt="" height="35px" width="35px" />
                                  </div>

                                  <!-- Device name column -->
                                  <div class="ms-2 q-tab-title" style="font-size: 16px;" data-toggle="tooltip"
                                    [title]="item?.deviceName">
                                    {{
                                    item?.deviceName == null
                                    ? "N/A" : item?.deviceName.length > 20
                                    ? item?.deviceName.slice(0, 20) + "..."
                                    : item?.deviceName
                                    }}
                                  </div>
                                </div>

                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2" *ngIf="
                                    (item &&
                                      item?.securityStatus === 'secure' &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRING_SOON') ||
                                    (item &&
                                      item?.detected === true &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRING_SOON')
                                  ">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "LICENSESUMMARY.ABOUTTOEXPIRE" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2" *ngIf="
                                    (item &&
                                      item?.securityStatus === 'secure' &&
                                      item?.licenseValidityDate ===
                                        'Free version') ||
                                    (item &&
                                      item?.detected === true &&
                                      item?.licenseValidityDate ===
                                        'Free version')
                                  ">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "LICENSESUMMARY.BUYPREMIUM" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2"
                                    *ngIf="item?.deviceType=='MOBILE'&&(item?.spStatus=='FAILED' || item?.atStatus=='FAILED' || item?.youtubeStatus=='FAILED' || item?.stStatus=='FAILED' || item?.dpStatus=='FAILED')">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "MANAGEDEVICE.CONTROLSTOPPEDWORKING" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2"
                                    *ngIf="item?.deviceType=='SYSTEM' &&(item?.spStatus=='FAILED' || item?.vpStatus=='FAILED')">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "MANAGEDEVICE.CONTROLSTOPPEDWORKING" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2"
                                    *ngIf="item?.deviceType=='SYSTEM' && parseFloat(item?.buildVersion) < parseFloat(DeskCompatibleVer)">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "SETTINGS.UPDATEREQUIRED" | translate
                                      }}
                                    </div>
                                  </div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2"
                                    *ngIf="item?.deviceType=='MOBILE' && !isCompatible(item?.buildVersion)">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{ "SETTINGS.UPDATEREQUIRED" | translate }}
                                    </div>
                                  </div>

                                </div>

                                <div class="d-flex align-items-center gap-2 "
                                  [ngStyle]="{'margin-top': hasAnyTag(item) ? '-23px' : '-10px'}">
                                  <div class="d-flex align-items-center ms-5">
                                    <img src="./assets/images/User.svg" style="margin-right:5px;" alt="" srcset=""
                                      height="12px" />
                                    <span style="color: #526B77; font-size:12px; font-weight:400;">
                                      {{item?.currentUserName || 'Unknown User' }}
                                    </span>
                                  </div>
                                  <div>
                                    <span class="badge" style="margin-right:4rem; border-radius:2px;"
                                      data-toggle="tooltip" title="{{getRoleLabel(item?.userRole)}}"
                                      [style.color]="privacyStatusClr" [style.background-color]="privacyStatusBg">{{
                                      getRoleLabel(item?.userRole) == null ? "" : getRoleLabel(item?.userRole)
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </span>
                            </tab-title-inline>
                          </div>
                          <div *ngIf="item?.expiringStatus === 'LICENSE_EXPIRED'" class="license-expired-banner">
                            {{ "MANAGEDEVICE.LICENSEEXP" | translate }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
                <!-- My Device Commands for 1 st index -->
                <div class="col-9">
                  <div class="p-4 qh-vertical-content mb-4 border-radius">
                    <div class="mt-3 fw-bold border-device mb-3"
                      *ngIf="getMyIndexData && getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED'">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
                          <p class="text-align-left-notification ms-2 mb-0">
                            {{ "MANAGEDEVICE.LICENSEEXP" | translate }}
                          </p>
                        </div>

                        <button class="bg-orgclr submit-btn-renew renew-btn" (click)="checkBeforeRenew()"
                          [ngStyle]="{ width: selectedLanguage !== 'ja' ? 'auto' : 'unset' }">
                          {{ "MANAGEDEVICE.RENEW" | translate }}
                        </button>
                      </div>
                    </div>
                    <div class="set-now-banner failed-setting mb-3"
                      *ngIf="getMyIndexData &&
                        getMyIndexData?.expiringStatus != 'LICENSE_EXPIRED' && getMyIndexData?.deviceType =='SYSTEM' && parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer) ">
                      <div class="banner-text">
                        <span class="banner-message failed-text ms-1">
                          <span>
                            <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt=""
                              class="banner-icon" />
                            {{ "LICENSESUMMARY.OUDATEDVER" | translate }} ({{ getMyIndexData?.buildVersion |
                            slice:0:4}}). {{ "LICENSESUMMARY.UPGRATETOLATESTFEATURE" | translate }}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="set-now-banner failed-setting mb-3"
                      *ngIf="getMyIndexData && getMyIndexData?.expiringStatus != 'LICENSE_EXPIRED' && getMyIndexData?.deviceType =='MOBILE' && !isCompatible(getMyIndexData?.buildVersion)">
                      <div class="banner-text">
                        <span class="banner-message failed-text ms-1">
                          <span>
                            <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt=""
                              class="banner-icon" />
                            {{ "LICENSESUMMARY.MOBILEOUDATEDVER" | translate }}
                          </span>
                        </span>
                      </div>
                    </div>

                    <div class="set-now-banner mb-3" *ngIf="!getMyIndexData?.isSettingPresent && 
        ((!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)) && getMyIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED' && getMyIndexData?.deviceType === 'SYSTEM') 
        || getMyIndexData?.deviceType === 'MOBILE')">

                      <div class="banner-text d-flex align-items-center">
                        <img *ngIf="showImage" src="../../../assets/images/Chips.png" alt="lock"
                          class="chips-icon me-2" />

                        <span class="banner-message">
                          {{ "MANAGEDEVICE.SETDEVICECONTROL" | translate }}
                        </span>
                      </div>

                      <button *ngIf="getMyIndexData?.deviceType == 'MOBILE'" class="set-now-button mt-2 mt-md-0"
                        (click)="managedDeviceControlBtnClick($event, getMyIndexData.id)"
                        [ngStyle]="{ width: selectedLanguage === 'ja' ? '145px' : '135px' }">
                        {{ "MANAGEDEVICE.SETNOW" | translate }}
                      </button>

                      <button *ngIf="getMyIndexData?.deviceType == 'SYSTEM'" class="set-now-button mt-2 mt-md-0"
                        (click)="managedSystemControlBtnClick(loggedInUserId, getMyIndexData.id)"
                        [ngStyle]="{ width: selectedLanguage === 'ja' ? '145px' : '135px' }">
                        {{ "MANAGEDEVICE.SETNOW" | translate }}
                      </button>
                    </div>


                    <div class="set-now-banner failed-setting mb-3" *ngIf="failedSettings.length > 0">
                      <div class="banner-text d-flex align-items-center" (click)="selectedIndexfailure(getMyIndexData)">
                        <span class="banner-message failed-text ms-1 d-flex align-items-center mb-0">

                          <span *ngIf="failedSettings.length > 1" class="d-flex align-items-center">
                            <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt=""
                              class="banner-icon me-2" />
                            {{ getFirstSetting() }} {{ "SETTINGS.AND" | translate }} {{ getFailedCount() - 1 }} {{
                            "SETTINGS.MOREFEATURES" | translate }}{{ getFailedCount() > 2 ?
                            's' : '' }}
                            {{ "MANAGEDEVICE.SYSTEMHASWORKING" | translate }}
                          </span>

                          <span *ngIf="failedSettings.length == 1" class="d-flex align-items-center">
                            <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt=""
                              class="me-2" />
                            {{ getFirstSetting() }} {{ "MANAGEDEVICE.HASSTOPEEDWORKING" | translate }}
                          </span>

                        </span>
                      </div>

                      <button *ngIf="failedSettings.length > 1" class="act-now-button"
                        (click)="openSendMultiControlPopup(getMyIndexData?.id,failedSettings.join(','),getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                        {{ "MANAGEDEVICE.ACTNOW" | translate }} <img src="./assets/images/Chevron Right.png">
                      </button>

                      <button *ngIf="failedSettings.length == 1" class="act-now-button"
                        (click)="openSendControlPopup(getMyIndexData?.id,failedSettings.join(','),getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                        {{ "MANAGEDEVICE.ACTNOW" | translate }} <img src="./assets/images/Chevron Right.png">
                      </button>
                    </div>

                    <div class="d-flex flex-wrap mb-3 mt-4 align-items-center py-2">
                      <p class="left d-flex align-items-center mb-0 me-3">
                        {{ "MANAGEDEVICE.DEVICECOMMANDS" | translate }}
                      </p>

                      <p class="myElement text-align-left cursor-pointer d-flex align-items-center mb-0 me-3"
                        (click)="deviceCommandsPopup()">
                        <img src="assets/images/OrangeInfo.png" alt="" class="me-1" />
                        <span class="text-decoration-underline">
                          {{ "MANAGEDEVICE.HOWSTHISWORK" | translate }}
                        </span>
                      </p>

                      <p class="right d-flex align-items-center mb-0 ms-auto" *ngIf="getMyIndexData?.lastSyncDate">
                        <img [src]="'DASHBOARD.VECTORROUND' | translate" width="18" height="21" alt="" class="me-1" />
                        {{ getMyIndexData?.lastSyncDate }}

                      </p>
                    </div>

                    <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                      <div class="d-flex justify-content-between align-items-center flex-wrap"></div>
                      <div class="d-flex flex-wrap mb-3">
                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                          class="syncdevice-card cursor-pointer" (click)="
                            sendCommand(getMyIndexData.id, 'SCAN_FROM_CLOUD')
                          ">
                          <img [src]="'MANAGEDEVICE.SCANIMG' | translate" alt="scan" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.SCANDEVICE" | translate }}
                          </div>
                        </div>
                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SYNCDEVICE' | translate }}"
                          class="syncdevice-card cursor-pointer" (click)="
                            openSyncScoreModal(getMyIndexData.id, 'SYNC_DEVICE')
                          ">
                          <img [src]="'DASHBOARD.GROUPSYNC' | translate" alt="sycn" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.SYNCDEVICE" | translate }}
                          </div>
                        </div>

                        <!-- sync initiated pop up -->
                        <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto"
                          id="LockPopup" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
                          aria-hidden="true">
                          <div
                            class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                            <div
                              class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
                              <ng-container *ngIf="!isLock">
                                <div class="mt-4">
                                  <img src="./assets/images/sync.svg" alt="" class="mx-auto" />
                                </div>
                                <h4 class="q-modal-heading mt-2 fw-bold">
                                  {{ "MANAGEDEVICE.SYNCINITIATED" | translate }}
                                </h4>
                                <div class="text-center mb-4 mt-3 d-flex justify-content-center">
                                  <div class="me-3">
                                    <!-- (click)="isLockClicked()" -->
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.RINGDEVICE' | translate }}"
                          class="syncdevice-card cursor-pointer" (click)="
                            sendCommand1(getMyIndexData.id, 'RING_DEVICE')
                          ">
                          <img [src]="'MANAGEDEVICE.RINGIMG' | translate" alt="ring" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.RINGDEVICE" | translate }}
                          </div>
                        </div>
                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCATE' | translate }}"
                          class="syncdevice-card cursor-pointer" (click)="gotoCommands(getMyIndexData.id, 'TRACE')">
                          <img [src]="'MANAGEDEVICE.LOCATEIMG' | translate" alt="locate.png" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.LOCATE" | translate }}
                          </div>
                        </div>
                        <div *ngIf="!lockData" data-toggle="tooltip" i18n-title
                          title="{{ 'MANAGEDEVICE.LOCK' | translate }}" class="syncdevice-card cursor-pointer"
                          (click)="sendCommand4()">
                          <img [src]="'MANAGEDEVICE.LOCKSMIMG' | translate" alt="lock" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.LOCK" | translate }}
                          </div>
                        </div>
                        <div *ngIf="lockData" data-toggle="tooltip" i18n-title
                          title="{{ 'MANAGEDEVICE.UNLOCK' | translate }}" class="syncdevice-card cursor-pointer"
                          (click)="sendCommand5(getMyIndexData.id, 'UNLOCK')">
                          <img [src]="'MANAGEDEVICE.UNLOCKSMIMG' | translate" alt="unLock" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.UNLOCK" | translate }}
                          </div>
                        </div>

                        <!-- pop up for lock -->
                        <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto"
                          id="LockPopup1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                          aria-labelledby="staticBackdropLabel" aria-hidden="true">
                          <div
                            class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                            <div
                              class="modal-content border-none px-4 shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
                              <ng-container *ngIf="!isLock">
                                <h4 class="q-modal-heading mt-4 fw-bold">
                                  {{ "SUCESSMESSAGE.LOCKDEVICE" | translate }}
                                </h4>
                                <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                  <span (click)="closeModal1()"><img src="./assets/images/otpCancel.svg" alt=""
                                      class="ms-xl-4" /></span>
                                </div>
                                <div class="mt-2">
                                  <img src="./assets/images/LockDevice1.svg" alt="" class="mx-auto" />
                                </div>
                                <p class="lockBlack-clr text-change mt-4" style="font-size: 16px">
                                  {{
                                  "SUCESSMESSAGE.DOYOUWANTTOLOCK" | translate
                                  }}
                                </p>
                                <ng-container *ngIf="errorMessage">
                                  <p class="errMessage" style="margin: 10px 90px">
                                    {{ errorMessage }}
                                  </p>
                                </ng-container>
                                <div class="text-center mb-4 d-flex justify-content-center mt-4">
                                  <div class="me-3">
                                    <button type="button" class="submit-btn bg-orgclr" (click)="
                                        sendCommand5(getMyIndexData.id, 'BLOCK')
                                      ">
                                      {{ "MANAGEDEVICE.YES" | translate }}
                                    </button>
                                  </div>
                                  <div class="">
                                    <button type="button" class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal"
                                      (click)="closeModal()">
                                      {{ "LOGIN.NO" | translate }}
                                    </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="isLock">
                                <div class="mt-4">
                                  <img src="./assets/images/SuccessLock.svg" alt="" class="mx-auto" />
                                </div>
                                <h5 *ngIf="Locked" class="fw-bold mt-4 deleteUser">
                                  {{
                                  "SUCESSMESSAGE.DEVICELOCKSUCCESSFULLY"
                                  | translate
                                  }}
                                </h5>
                                <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                  <span (click)="closeModal1()"><img src="./assets/images/otpCancel.svg" alt=""
                                      class="ms-xl-4" /></span>
                                </div>
                                <h5 *ngIf="!Locked" class="fw-bold mt-4 deleteUser">
                                  {{
                                  "SUCESSMESSAGE.DEVICEUNLOCKSUCCESSFULLY"
                                  | translate
                                  }}
                                </h5>
                                <div data-toggle="tooltip" i18n-title title="{{
                                    'MANAGEDEVICE.LOCATE' | translate
                                  }}" class="cursor-pointer" (click)="
                                    gotoCommands(getMyIndexData.id, 'TRACE')
                                  ">
                                  <h5 style="
                                      color: #f16522;
                                      border-bottom: 1px solid #f16522;
                                      display: inline-block;
                                      padding-bottom: 2px;
                                    ">
                                    {{ "MANAGEDEVICE.VIEWLOCATION" | translate}}
                                  </h5>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.WIPE' | translate }}"
                          class="syncdevice-card cursor-pointer" (click)="sendCommand2()">
                          <img [src]="'MANAGEDEVICE.WIPEIMG' | translate" alt="wipe" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.WIPE" | translate }}
                          </div>
                        </div>

                        <!--  pop up for wipe-->
                        <div class="modal mx-auto fade" id="WipePopup" data-bs-backdrop="static"
                          data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
                          aria-hidden="true">
                          <div
                            class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                            <div
                              class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
                              <ng-container *ngIf="!isLock">
                                <h4 class="q-modal-heading mt-4 fw-bold">
                                  {{ "SUCESSMESSAGE.WIPEDATA" | translate }}
                                </h4>
                                <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                  <span (click)="closeModal2()"><img src="./assets/images/otpCancel.svg" alt=""
                                      class="ms-xl-4" /></span>
                                </div>
                                <div class="mt-2">
                                  <img src="./assets/images/WipeData.svg" alt="" class="mx-auto" />
                                </div>

                                <p class="lockBlack-clr text-change mt-4" style="font-size: 16px">
                                  {{ "MANAGEDEVICE.WIPEALLDATAS" | translate }}
                                  {{ deviceName }}
                                </p>

                                <ng-container *ngIf="errorMessage">
                                  <p class="errMessage" style="margin: 10px 90px">
                                    {{ errorMessage }}
                                  </p>
                                </ng-container>
                                <div class="text-center mb-4 d-flex justify-content-center mt-4">
                                  <div class="me-3">
                                    <button type="button" class="submit-btn bg-orgclr" (click)="
                                        sendCommand3(getMyIndexData.id, 'WIPE')
                                      ">
                                      {{ "MANAGEDEVICE.YES" | translate }}
                                    </button>
                                  </div>
                                  <div class="">
                                    <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeModal()">
                                      {{ "LOGIN.NO" | translate }}
                                    </button>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="isLock">
                                <div class="mt-4">
                                  <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                                </div>
                                <h5 class="q-modal-heading mt-4 deleteUser">
                                  {{
                                  "SUCESSMESSAGE.WIPEDATACOMMAND" | translate
                                  }}
                                </h5>
                                <div class="text-center">
                                  <div class="text-lg font-normal">
                                    <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4"
                                      data-bs-dismiss="modal">
                                      {{ "SIGNUP.DONE" | translate }}
                                    </button>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>

                        <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.ANTITHEFT' | translate }}"
                          class="antiTheft-card cursor-pointer" (click)="sendCommand6()">
                          <img [src]="'DASHBOARD.VECTOR' | translate" class="corner-image" width="50" height="50"
                            viewBox="0 0 50 50" alt="theft" />
                          <img [src]="'MANAGEDEVICE.ANTITHEFTIMG' | translate" alt="theft" />
                          <div class="mt-2">
                            {{ "MANAGEDEVICE.ANTITHEFT" | translate }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- pop up for anti-theft -->

                    <div *ngFor="let item of tabsData; let i = index" class="modal mx-auto fade" id="AntiTheftPopup"
                      data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                      aria-labelledby="staticBackdropLabel" aria-hidden="true">
                      <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                        <div
                          class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none"
                          style="width: 683px">
                          <div>
                            <h4 class="q-heading mt-4">
                              {{ "SETTINGS.ANTITHEFT" | translate }}
                            </h4>

                            <div style="position: absolute; top: 25px; right: 25px">
                              <span (click)="closeModal3()"><img src="./assets/images/otpCancel.svg" alt=""
                                  class="ms-xl-4" /></span>
                            </div>
                          </div>

                          <div>
                            <p class="lockBlack-clr text-change">
                              {{ "MANAGEDEVICE.ANTITHEFTCOMMAND" | translate }}
                            </p>
                          </div>

                          <div class="p-4" [ngClass]="
                              selectedI === 0
                                ? 'content-border-radius'
                                : 'rounded-border-radius'
                            ">
                            <div class="d-flex justify-content-between align-items-center flex-wrap"></div>
                            <div class="d-flex flex-wrap mb-3 justify-content-center" style="width: 600px">
                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getMyIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  ">
                                  <div data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                    style="width: 126px" (click)="
                                      selectedIndex1(getMyIndexData.id, 'PHOTO')
                                    " (click)="
                                      sendCommand7(
                                        getMyIndexData.id,
                                        'ANTITHEFT_SETTINGS'
                                      )
                                    ">
                                    <img src="./assets/images/TakePicture.png"
                                      alt='{{ "MANAGEDEVICE.TAKEPICTUR" | translate }}' class="button-image" />
                                    <div class="mt-1 font-12">
                                      {{"MANAGEDEVICE.TAKEPICTUR" | translate}}
                                    </div>
                                  </div>
                                </div>
                              </ng-container>

                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getMyIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                  style="width: 126px" (click)="
                                    selectedIndex1(getMyIndexData.id, 'AUDIO')
                                  " (click)="
                                    sendCommand7(
                                      getMyIndexData.id,
                                      'ANTITHEFT_SETTINGS'
                                    )
                                  ">
                                  <img src="./assets/images/microphone.png"
                                    alt="{{ 'MANAGEDEVICE.AUTOCAPTUREAUDIO' | translate }}" class="button-image" />
                                  <div class="mt-1 font-12">
                                    {{
                                    "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate
                                    }}</div>
                                </div>
                              </ng-container>

                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getMyIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                  style="width: 126px" (click)="
                                    selectedIndex1(getMyIndexData.id, 'VIDEO')
                                  " (click)="
                                    sendCommand7(
                                      getMyIndexData.id,
                                      'ANTITHEFT_SETTINGS'
                                    )
                                  ">
                                  <img src="./assets/images/TakeVideo.png"
                                    alt='{{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}' class="button-image" />
                                  <div class="mt-1 font-12">
                                    {{
                                    "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate
                                    }}
                                  </div>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="getMyIndexData?.osVersion <= 9">
                                <div class="row">
                                  <form [formGroup]="autoDialForm">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate !=
                                          'Free version' &&
                                        getMyIndexData?.expiringStatus !==
                                          'LICENSE_EXPIRED'
                                      " data-toggle="tooltip" [ngClass]="{
                                        'antiTheft-card antiTheft-card-border cursor-pointer':
                                          !autodial,
                                        ' actives cursor-pointer': autodial
                                      }" style="width: 126px" (click)="
                                        selectedIndex1(
                                          getMyIndexData.id,
                                          'CALL'
                                        )
                                      ">
                                      <img src="./assets/images/AutoDial1.svg" alt="Auto Dial" class="button-image" />
                                    </div>
                                  </form>
                                </div>
                              </ng-container>

                              <!-- free vesrion disable commands-->

                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getMyIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  ">
                                  <div data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                    <img src="./assets/images/TakePicture.png"
                                      alt='{{"MANAGEDEVICE.TAKEPICTUR" | translate}}' />
                                    <div class="mt-1 font-12">{{"MANAGEDEVICE.TAKEPICTUR" | translate}}</div>
                                  </div>
                                </div>
                              </ng-container>

                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getMyIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                  <img src="./assets/images/microphone.png"
                                    alt='{{"MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate}}' />
                                  <div class="mt-1 font-12">
                                    {{
                                    "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate
                                    }}</div>
                                </div>
                              </ng-container>

                              <ng-container>
                                <div *ngIf="
                                    getMyIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getMyIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                  <img src="./assets/images/TakeVideo.png"
                                    alt='{{"MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate}}' />
                                  <div class="mt-1 font-12">
                                    {{
                                    "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate
                                    }}</div>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="getMyIndexData?.osVersion <= 9">
                                <div class="row">
                                  <form [formGroup]="autoDialForm">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                          'Free version' ||
                                        getMyIndexData?.expiringStatus ===
                                          'LICENSE_EXPIRED'
                                      " data-toggle="tooltip" class="antiTheft-card" style="width: 126px">
                                      <img src="./assets/images/AutoDial.png" alt="Auto Dial" />
                                    </div>
                                  </form>
                                </div>
                              </ng-container>
                              <div *ngIf="
                                  getMyIndexData?.licenseValidityDate ===
                                  'Free version'
                                ">
                                <p class="lockBlack-clr text-change mt-2">
                                  {{
                                  "MANAGEDEVICE.UPGRADETOACCESS" | translate
                                  }}
                                </p>
                                <button type="button" class="bg-orgclr submit-btn shadow-none"
                                  (click)="checkBeforeRenew()">
                                  {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                </button>
                              </div>
                              <div *ngIf="
                                  getMyIndexData?.expiringStatus ===
                                  'LICENSE_EXPIRED'
                                ">
                                <p class="lockBlack-clr text-change mt-2">
                                  {{ "MANAGEDEVICE.RENEWTOACCESS" | translate }}
                                </p>
                                <button type="button" class="bg-orgclr submit-btn shadow-none"
                                  (click)="checkBeforeRenew()">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                              </div>

                              <div class="auto-dial mt-3" *ngIf="autodial">
                                <div class="mt-4"></div>
                                <div class="act-text-line mt-3 px-5">
                                  {{ "MANAGEDEVICE.AUTODIALDESC" | translate }}
                                </div>
                                <div class="act-text-line mt-3 px-5">
                                  <label for="name" class="q-form-label">{{ "MANAGEDEVICE.ENTERMOBN" | translate
                                    }}<span class="text-danger">*</span></label>
                                </div>
                                <div class="d-flex px-5 mt-2 w-100">
                                  <form [formGroup]="autoDialForm">
                                    <ngx-intl-tel-input [cssClass]="'form-control q-form-control'"
                                      [onlyCountries]="['in']" [enableAutoCountrySelect]="false"
                                      [enablePlaceholder]="true" [searchCountryFlag]="true"
                                      customPlaceholder="Enter Your Mobile Number" [searchCountryField]="[
                                        SearchCountryField.Iso2,
                                        SearchCountryField.Name
                                      ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                      [maxLength]="15" [phoneValidation]="true" name="phone" type="number"
                                      formControlName="mobileNo" (keydown)="removeSpace1($event)"
                                      (ngModelChange)="onFocusOutMobile($event)"></ngx-intl-tel-input>
                                    <ng-container *ngIf="mobileNoWrong">
                                      <p class="errMessage">
                                        {{
                                        "MANAGEDEVICE.MINANDMAX8" | translate
                                        }}
                                      </p>
                                    </ng-container>

                                    <ng-container *ngIf="errorMessage">
                                      <p class="errMessage">
                                        {{ errorMessage }}
                                      </p>
                                    </ng-container>
                                  </form>

                                  <button class="newrenew-button submit-btn-renew bg-orgclr ms-3" type="submit" (click)="
                                      sendCommand7(
                                        getMyIndexData.id,
                                        'ANTITHEFT_SETTINGS'
                                      )
                                    ">
                                    {{ "MANAGEDEVICE.AUTODIAL" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- My Device for 1st index device details -->
                    <ng-container *ngIf="selectedI === 0">
                      <div class="col-12 mb-3 mt-3">
                        <span btn4 *ngIf="
                            getMyIndexData?.productKeyType === 'FAMILY_PACK'
                          ">
                          <button (click)="deactivate(getMyIndexData)" class="q-form-white-submit mb-2">
                            {{ "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate }}
                          </button></span>
                      </div>
                      <!-- </div> -->

                      <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                        <div class="d-flex flex-wrap mb-1">
                          <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                            class="syncdevice-card cursor-pointer"
                            [class.btnDisabled]="isScanButtonDisabled || (parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)) || getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED'"
                            (click)="
                              openSyncScoreModalnew(
                                getMyIndexData.id,
                                'SCAN_FROM_CLOUD',
                                getMyIndexData?.deviceType,
                                true
                              )
                            ">
                            <!-- (click)="(getMyIndexData.id,'SCORE')" -->
                            <img [src]="'MANAGEDEVICE.SCANIMG' | translate" alt="scan" />
                            <div class="mt-2">
                              {{ "MANAGEDEVICE.SCAN" | translate }}
                            </div>
                          </div>
                          <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SYNC' | translate }}"
                            class="syncdevice-card cursor-pointer" (click)="
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'UPDATE_ALL_DETAILS');
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'SCORE'); ">
                            <!-- (click)="(getMyIndexData.id,'SCORE')" -->
                            <img [src]="'MANAGEDEVICE.SCOREIMG' | translate" alt="scan" />
                            <div class="mt-2">
                              {{ "MANAGEDEVICE.SYNC" | translate }}
                            </div>
                          </div>
                        </div>
                        <div *ngIf="isScanButtonDisabled"><img src="assets/images/Info.svg" alt="" class="mx-1" />{{
                          "MANAGEDEVICE.SCANDISABLEMSG" | translate }}</div>
                      </div>
                    </ng-container>
                    <!-- My Device for 2st index device details -->
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                        <div class="d-flex flex-wrap mb-1">
                          <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                            class="syncdevice-card cursor-pointer"
                            [class.btnDisabled]="isScanButtonDisabled || (parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)) || getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED'"
                            (click)="
                              openSyncScoreModalnew(
                                getMyIndexData.id,
                                'SCAN_FROM_CLOUD',
                                getMyIndexData?.deviceType,
                                true
                              )
                            ">
                            <!-- (click)="(getMyIndexData.id,'SCORE')" -->
                            <img [src]="'MANAGEDEVICE.SCANIMG' | translate" alt="scan" />
                            <div class="mt-2">
                              {{ "MANAGEDEVICE.SCAN" | translate }}
                            </div>
                          </div>
                          <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SYNC' | translate }}"
                            class="syncdevice-card cursor-pointer" (click)="
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'UPDATE_ALL_DETAILS');
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'SCORE') ">
                            <img [src]="'MANAGEDEVICE.SCOREIMG' | translate" alt="sync" />
                            <div class="mt-2">
                              {{ "MANAGEDEVICE.SYNC" | translate }}
                            </div>
                          </div>
                        </div>
                        <div *ngIf="isScanButtonDisabled"><img src="assets/images/Info.svg" alt="" class="mx-1" />{{
                          "MANAGEDEVICE.SCANDISABLEMSG" | translate }}</div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- device controls for 1st index-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI === 0">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                                  dcExpanded
                                    ? 'accordion-button shadow-none relative p-4 bg-white border-0 d-flex align-items-center'
                                    : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0 d-flex align-items-center'
                                " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="deviceControlToggle()">

                            <div *ngIf="hasControlFailure(getMyIndexData)" class="me-2" style="margin-top:-4px;">
                              <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
                            </div>

                            <span>
                              {{ "MANAGEDEVICE.DEVICECONTROL" | translate }}
                            </span>

                            <div *ngIf="showImage" class="ms-2 py-2 mb-2" style="margin-top:0.3rem;">
                              <img src="../../../assets/images/Chips.png" alt="chips" />
                            </div>
                          </button>

                          <div class="row p-4 qh-vertical-content align-items-center" [hidden]="!dcExpanded">
                            <div
                              *ngIf="(!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)) && getMyIndexData?.deviceType === 'SYSTEM') || getMyIndexData?.deviceType === 'MOBILE' "
                              class="justify-content-between align-items-center info-bar ms-1 mb-3">
                              <span class="left-text">
                                {{ "MANAGEDEVICE.NOTSEEING" | translate }}
                                <button class="transparent-button"
                                  (click)="fetchSettingStatus(getMyIndexData.id,getMyIndexData?.deviceType)">
                                  <img src="../../../assets/images/Ellipse 105.png" class="mb-2px" />
                                  <span class="refresh-color ms-1">{{ "MANAGEDEVICE.REFRESH" | translate }}</span>
                                </button>
                              </span>
                              <span class="right-text justify-content-end" *ngIf="getMyIndexData?.changeDate">
                                {{ "MANAGEDEVICE.LASTCHANGE" | translate }} {{ getMyIndexData?.changeDate}} {{
                                "MANAGEDEVICE.BY" | translate }} {{
                                getMyIndexData?.lastChangeName }}
                              </span>
                            </div>

                            <!-- Header -->
                            <div class="device-controls w-100 pe-4 ms-3 ">
                              <div class="row mt-3 d-flex align-items-center fw-bold">
                                <div class="col-3">{{ "MANAGEDEVICE.DEVICECONTROL" | translate }}</div>
                                <div class="col-3">{{ "MANAGEDEVICE.TURNONOFF" | translate }}</div>
                                <div class="col-3">{{ "MANAGEDEVICE.STATUS" | translate }}</div>
                              </div>
                            </div>

                            <!-- ========== MOBILE CONTROLS ========== -->
                            <div class="w-100 mt-3 pe-4" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                              <!-- Each row -->
                              <div class="row d-flex align-items-center py-3 ms-1" [ngClass]="{ 'alt-bg': i % 2 !== 0 }"
                                *ngFor="let ctrl of [
                {label:'MANAGEDEVICE.SMARTPARENTING', val:getMyIndexData?.smartParenting, status:getMyIndexData?.spStatus, key:'SMART_PARENTING_SETTING'},
                {label:'MANAGEDEVICE.SCREENTIME', val:getMyIndexData?.screenTime, status:getMyIndexData?.stStatus, key:'SCREEN_TIME_SETTING'},
                {label:'MANAGEDEVICE.YOTUBESUP', val:getMyIndexData?.youtubeSupervision, status:getMyIndexData?.youtubeStatus, key:'YOUTUBE_SUPERVISION_SETTING'},
                {label:'MANAGEDEVICE.ANTITHEFTS', val:getMyIndexData?.antiTheft, status:getMyIndexData?.atStatus, key:'ANTITHEFT_SETTING'},
                {label:'MANAGEDEVICE.DEVICEPIN', val:getMyIndexData?.devicePin, status:getMyIndexData?.dpStatus, key:'PIN_SETTING'}
              ]; let i = index">
                                <div class="col-3 ms-2">{{ ctrl.label | translate }}</div>
                                <div class="col-3 d-flex align-items-center">
                                  <div class="device-control-btn"
                                    *ngIf="isCompatible(getMyIndexData?.buildVersion); else notSupported"
                                    [ngClass]="ctrl.val ? 'on':'off'">
                                    <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                      {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                    </div>
                                  </div>
                                  <div class="col-3" *ngIf="isCompatible(getMyIndexData?.buildVersion)">
                                    <div class="dropdown dashboard-tooltip cursor-pointer ms-1"
                                      *ngIf="ctrl.key === 'ANTITHEFT_SETTING' && (ctrl.val !== getMyIndexData?.intruderAlert)">
                                      <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="info"
                                        class="me-1" />
                                      <!-- Popup -->
                                      <div class="dropdown-content antitheft ">
                                        <p class="mb-2 anti-theft-text">{{ "SETTINGS.PARTIALLYON" | translate }}</p>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                          <span class="anti-theft">{{ "SETTINGS.ANTITHEFT" | translate }}</span>
                                          <span class="device-control-btn" [ngClass]="ctrl.val ? 'on':'off'">
                                            <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                              {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                            </div>
                                          </span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                          <span class="anti-theft">{{"SETTINGS.Intruder" | translate }}</span>
                                          <span class="device-control-btn"
                                            [ngClass]="getMyIndexData?.intruderAlert ? 'on':'off'">
                                            <div class="text-layout text-center"
                                              [ngClass]="getMyIndexData?.intruderAlert ? 'on':'off'">
                                              {{(getMyIndexData?.intruderAlert === false ? 'SETTINGS.OFF' :
                                              'SETTINGS.ON') | translate }}
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <ng-template #notSupported>
                                  <div class="device-control-btn off">
                                    <div class="status-disable-text text-center off">{{ 'SETTINGS.OFF' | translate }}
                                    </div>
                                  </div>
                                </ng-template>
                                <div class="col-5 ">
                                  <div class="status-cell">
                                    <div class="text-layouts me-2"
                                      *ngIf="isCompatible(getMyIndexData?.buildVersion); else naStatus"
                                      [ngClass]="getStatusClass(ctrl.status)">
                                      {{ (ctrl.status != null
                                      ? ('STATUS.' + ctrl.status)
                                      : 'STATUS.APPLIED') | translate }}
                                    </div>
                                    <p *ngIf="ctrl.status==='FAILED' && getMyIndexData?.expiringStatus !='LICENSE_EXPIRED' && isCompatible(getMyIndexData?.buildVersion)"
                                      class="text-decoration-underline cursor-pointer m-0 no-wrap"
                                      (click)="openSendControlPopup(getMyIndexData?.id,ctrl.key,getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                                      {{ "MANAGEDEVICE.WHYITSFAILED" | translate }}
                                    </p>
                                  </div>
                                </div>
                                <ng-template #naStatus>
                                  <div class="status-disable-text text-center off ">{{ 'SETTINGS.NA' | translate }}
                                  </div>
                                </ng-template>
                              </div>
                            </div>

                            <!-- ========== SYSTEM CONTROLS ========== -->
                            <div class="w-100 mt-3 pe-4" *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                              <div class="row d-flex align-items-center ms-1 py-3" [ngClass]="{ 'alt-bg': i % 2 !== 0 }"
                                *ngFor="let ctrl of [
                {label:'MANAGEDEVICE.SMARTPARENTING', val:getMyIndexData?.smartParenting, status:getMyIndexData?.spStatus, key:'SYSTEM_PARENTAL_SETTINGS', onTime: undefined},
                {label:'MANAGEDEVICE.FIREWALLIDSIPS', val:getMyIndexData?.firewallProtection, status:getMyIndexData?.fpStatus, key:'FIREWALL', onTime: undefined},
                {label:'MANAGEDEVICE.RANSOMWARE', val:getMyIndexData?.ransomwareProtection, status:getMyIndexData?.rpStatus, key:'RANSOMEWARE', onTime: getMyIndexData?.rpOnTime},
                {label:'MANAGEDEVICE.VIRUSPROTECTION', val:getMyIndexData?.virusProtection, status:getMyIndexData?.vpStatus, key:'VIRUS', onTime: getMyIndexData?.vpOnTime}
              ]; let i = index">

                                <div class="col-3 ms-2">{{ ctrl.label | translate }}</div>

                                <div class="col-3">
                                  <ng-container
                                    *ngIf="!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)); else notSupported">
                                    <div class="device-control-btn" [ngClass]="ctrl.val ? 'on':'off'">
                                      <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                        {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #notSupported>
                                    <div class="device-control-btn off">
                                      <div class="status-disable-text text-center off">{{ 'SETTINGS.OFF' | translate }}
                                      </div>
                                    </div>
                                  </ng-template>
                                </div>

                                <div class="col-5">
                                  <div class="status-cell">
                                    <ng-container
                                      *ngIf="!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)); else naStatus">
                                      <div class="text-layouts me-2" [ngClass]="getStatusClass(ctrl.status)">
                                        {{ (ctrl.status != null
                                        ? ('STATUS.' + ctrl.status)
                                        : 'STATUS.APPLIED') | translate }}
                                      </div>
                                      <p *ngIf="ctrl.status==='FAILED' && getMyIndexData?.expiringStatus !='LICENSE_EXPIRED'"
                                        class="text-decoration-underline cursor-pointer m-0 no-wrap"
                                        (click)="openSendControlPopup(getMyIndexData?.id,ctrl.key,getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                                        {{ "MANAGEDEVICE.WHYITSFAILED" | translate }}
                                      </p>
                                      <p class="m-0 opacity-50 font-400-12"
                                        *ngIf="(ctrl.key==='RANSOMEWARE' || ctrl.key==='VIRUS' ) && ctrl.val === false && ctrl.onTime != null">
                                        <img src="./assets/images/Info.png" />{{ ctrl.onTime}}
                                      </p>
                                    </ng-container>
                                    <ng-template #naStatus>
                                      <div class="status-disable-text text-center off">{{ 'SETTINGS.NA' | translate }}
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Buttons -->
                            <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'" class="button-container ms-4 py-2">
                              <button
                                [disabled]="(getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' && getMyIndexData?.productType !== 'MOBSEC_BASIC') || !isCompatible(getMyIndexData?.buildVersion)"
                                [ngClass]="(getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' && getMyIndexData?.productType !== 'MOBSEC_BASIC') || !isCompatible(getMyIndexData?.buildVersion)? 'q-invalid-button' : 'bg-orgclr manage-device-control shadow-none'"
                                (click)="managedDeviceControlBtnClick($event, getMyIndexData.id)"
                                class="manage-device-btn">
                                {{ "MANAGEDEVICE.MANAGEDEVICECONTROL" | translate }}
                              </button>
                            </div>

                            <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'" class="button-container ms-4 py-4">
                              <button
                                [disabled]="getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' || parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)"
                                [ngClass]="getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' || parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer) ? 'q-invalid-button' : 'bg-orgclr manage-device-control shadow-none'"
                                (click)="managedSystemControlBtnClick(loggedInUserId,getMyIndexData.id)"
                                class="manage-device-btn">
                                {{ "MANAGEDEVICE.MANAGEDEVICECONTROL" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>


                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI === 0">
                      <div id="accordionDevice"
                        class="accordion device-accordion left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between"
                        [ngClass]="
                          selectedI ? 'border-radius' : 'border-radius'
                        ">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8 mb-3">
                              <div class="d-flex flex-wrap mt-3">
                                <!-- <div class="q-tab-content-title"> -->
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getMyIndexData?.deviceName == null
                                      ? "N/A"
                                      : getMyIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getMyIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getMyIndexData.deviceType,
                                                getMyIndexData.id
                                              )
                                            ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" #testInput autocomplete="off" minlength="3"
                                              maxlength="20" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>



                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getMyIndexData)
                                  ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="removeDevicePopup(getMyIndexData)"
                                  class="q-form-white-submit mb-2 me-3">
                                  {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                                </button></span>
                              <span btn4 *ngIf="
                                  getMyIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                                <button (click)="deactivate(getMyIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                  }}
                                </button></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI === 0">
                      <div id="accordionDevice"
                        class="accordion device-accordion left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between"
                        [ngClass]="
                          selectedI ? 'border-radius' : 'border-radius'
                        ">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>

                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <!-- <div class="q-tab-content-title"> -->
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>
                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                      <button [disabled]="
                                          getMyIndexData?.productLink == null
                                        " [ngClass]="
                                          getMyIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getMyIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}
                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }}</p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>
                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button *ngIf="
                                      getMyIndexData?.expirydays < 90 ||
                                      getMyIndexData?.productName ==
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                  <button *ngIf="
                                      getMyIndexData?.expirydays >= 90 &&
                                      getMyIndexData?.productName !=
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                </div>
                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                      <button [disabled]="
                                          getMyIndexData?.productLink == null
                                        " [ngClass]="
                                          getMyIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getMyIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- device controls for 2nd index-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
            dcExpanded
              ? 'accordion-button shadow-none relative p-4 bg-white border-0'
              : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
          " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}" aria-expanded="false"
                            attr.aria-controls="collapseOne{{ 0 }}" (click)="deviceControlToggle()">

                            <div *ngIf="hasControlFailure(getMyIndexData)" class="me-2" style="margin-top:-4px;">
                              <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
                            </div>
                            <span>
                              {{ "MANAGEDEVICE.DEVICECONTROL" | translate }}
                            </span>
                            <div *ngIf="showImage" class="ms-2 py-2 mb-2" style="margin-top:0.3rem;">
                              <img src="../../../assets/images/Chips.png" alt="lock" />
                            </div>
                          </button>

                          <div class="row p-4 qh-vertical-content align-items-center" [hidden]="!dcExpanded">
                            <div
                              *ngIf="(!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)) && getMyIndexData?.deviceType === 'SYSTEM') || getMyIndexData?.deviceType === 'MOBILE' "
                              class="justify-content-between align-items-center info-bar ms-1 mb-3">
                              <span class="left-text">{{ "MANAGEDEVICE.NOTSEEING" | translate }}
                                <button class="transparent-button"
                                  (click)="fetchSettingStatus(getMyIndexData.id,getMyIndexData?.deviceType)">
                                  <img src="../../../assets/images/Ellipse 105.png" class="mb-2px" />
                                  <span class="refresh-color ms-1">{{ "MANAGEDEVICE.REFRESH" | translate }}</span>
                                </button>
                              </span>
                              <span class="right-text justify-content-end" *ngIf="getMyIndexData?.changeDate">
                                {{ "MANAGEDEVICE.LASTCHANGE" | translate }} {{ getMyIndexData?.changeDate}} {{
                                "MANAGEDEVICE.BY" | translate }} {{
                                getMyIndexData?.lastChangeName }}
                              </span>
                            </div>

                            <!-- Header -->
                            <div class="device-controls w-100 pe-4 ms-3 ">
                              <div class="row mt-3 d-flex align-items-center fw-bold">
                                <div class="col-3">{{ "MANAGEDEVICE.DEVICECONTROL" | translate }}</div>
                                <div class="col-3">{{ "MANAGEDEVICE.TURNONOFF" | translate }}</div>
                                <div class="col-3">{{ "MANAGEDEVICE.STATUS" | translate }}</div>
                              </div>
                            </div>

                            <!-- ========== MOBILE CONTROLS ========== -->
                            <div class="w-100 mt-3 pe-4" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                              <!-- Each row -->
                              <div class="row d-flex align-items-center py-3 ms-1" [ngClass]="{ 'alt-bg': i % 2 !== 0 }"
                                *ngFor="let ctrl of [
                {label:'MANAGEDEVICE.SMARTPARENTING', val:getMyIndexData?.smartParenting, status:getMyIndexData?.spStatus, key:'SMART_PARENTING_SETTING'},
                {label:'MANAGEDEVICE.SCREENTIME', val:getMyIndexData?.screenTime, status:getMyIndexData?.stStatus, key:'SCREEN_TIME_SETTING'},
                {label:'MANAGEDEVICE.YOTUBESUP', val:getMyIndexData?.youtubeSupervision, status:getMyIndexData?.youtubeStatus, key:'YOUTUBE_SUPERVISION_SETTING'},
                {label:'MANAGEDEVICE.ANTITHEFTS', val:getMyIndexData?.antiTheft, status:getMyIndexData?.atStatus, key:'ANTITHEFT_SETTING'},
                {label:'MANAGEDEVICE.DEVICEPIN', val:getMyIndexData?.devicePin, status:getMyIndexData?.dpStatus, key:'PIN_SETTING'}
              ]; let i = index">
                                <div class="col-3 ms-2 ">{{ ctrl.label | translate }}</div>
                                <div class="col-3  d-flex align-items-center">
                                  <div class="device-control-btn"
                                    *ngIf="isCompatible(getMyIndexData?.buildVersion); else notSupported"
                                    [ngClass]="ctrl.val ? 'on':'off'">
                                    <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                      {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                    </div>
                                  </div>
                                  <div class="col-3" *ngIf="isCompatible(getMyIndexData?.buildVersion)">
                                    <div class="dropdown dashboard-tooltip cursor-pointer ms-1"
                                      *ngIf="ctrl.key === 'ANTITHEFT_SETTING' && (ctrl.val !== getMyIndexData?.intruderAlert)">
                                      <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="info"
                                        class="me-1" />
                                      <!-- Popup -->
                                      <div class="dropdown-content antitheft ">
                                        <p class="mb-2 anti-theft-text">{{ "SETTINGS.PARTIALLYON" | translate }}</p>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                          <span class="anti-theft">{{"SETTINGS.ANTITHEFT" | translate}}</span>
                                          <span class="device-control-btn" [ngClass]="ctrl.val ? 'on':'off'">
                                            <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                              {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                            </div>
                                          </span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                          <span class="anti-theft">{{"SETTINGS.Intruder" | translate}}</span>
                                          <span class="device-control-btn"
                                            [ngClass]="getMyIndexData?.intruderAlert ? 'on':'off'">
                                            <div class="text-layout text-center"
                                              [ngClass]="getMyIndexData?.intruderAlert ? 'on':'off'">
                                              {{ (getMyIndexData?.intruderAlert === false ? 'SETTINGS.OFF' :
                                              'SETTINGS.ON') | translate }}
                                            </div>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <ng-template #notSupported>
                                    <div class="device-control-btn off">
                                      <div class="status-disable-text text-center off">{{ 'SETTINGS.OFF' | translate }}
                                      </div>
                                    </div>
                                  </ng-template>
                                </div>
                                <div class="col-5">
                                  <div class="status-cell">
                                    <div class="text-layouts me-2" [ngClass]="getStatusClass(ctrl.status)"
                                      *ngIf="isCompatible(getMyIndexData?.buildVersion); else naStatus">
                                      {{ (ctrl.status != null
                                      ? ('STATUS.' + ctrl.status)
                                      : 'STATUS.APPLIED') | translate }}
                                    </div>
                                    <p *ngIf="ctrl.status==='FAILED' && getMyIndexData?.expiringStatus !='LICENSE_EXPIRED'  && isCompatible(getMyIndexData?.buildVersion)"
                                      class="text-decoration-underline cursor-pointer m-0 no-wrap"
                                      (click)="openSendControlPopup(getMyIndexData?.id,ctrl.key,getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                                      {{ "MANAGEDEVICE.WHYITSFAILED" | translate }}
                                    </p>
                                  </div>
                                </div>
                                <ng-template #naStatus>
                                  <div class="status-disable-text text-center off ">{{ 'SETTINGS.NA' | translate }}
                                  </div>
                                </ng-template>
                              </div>
                            </div>

                            <!-- ========== SYSTEM CONTROLS ========== -->
                            <div class="w-100 mt-3 pe-4" *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                              <div class="row d-flex align-items-center ms-1 py-3" [ngClass]="{ 'alt-bg': i % 2 !== 0 }"
                                *ngFor="let ctrl of [
                {label:'MANAGEDEVICE.SMARTPARENTING', val:getMyIndexData?.smartParenting, status:getMyIndexData?.spStatus, key:'SYSTEM_PARENTAL_SETTINGS', onTime: undefined},
                {label:'MANAGEDEVICE.FIREWALLIDSIPS', val:getMyIndexData?.firewallProtection, status:getMyIndexData?.fpStatus, key:'FIREWALL', onTime: undefined},
                {label:'MANAGEDEVICE.RANSOMWARE', val:getMyIndexData?.ransomwareProtection, status:getMyIndexData?.rpStatus, key:'RANSOMEWARE', onTime: getMyIndexData?.rpOnTime},
                {label:'MANAGEDEVICE.VIRUSPROTECTION', val:getMyIndexData?.virusProtection, status:getMyIndexData?.vpStatus, key:'VIRUS', onTime: getMyIndexData?.vpOnTime}
              ]; let i = index">

                                <div class="col-3 ms-2">{{ ctrl.label | translate }}</div>

                                <div class="col-3">
                                  <ng-container
                                    *ngIf="!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)); else notSupported">
                                    <div class="device-control-btn" [ngClass]="ctrl.val ? 'on':'off'">
                                      <div class="text-layout text-center" [ngClass]="ctrl.val ? 'on':'off'">
                                        {{ (ctrl.val === false ? 'SETTINGS.OFF' : 'SETTINGS.ON') | translate }}
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #notSupported>
                                    <div class="device-control-btn off">
                                      <div class="status-disable-text text-center off">{{ 'SETTINGS.OFF' | translate }}
                                      </div>
                                    </div>
                                  </ng-template>
                                </div>

                                <div class="col-5">
                                  <div class="status-cell">
                                    <ng-container
                                      *ngIf="!(parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)); else naStatus">
                                      <div class="text-layouts me-2" [ngClass]="getStatusClass(ctrl.status)">
                                        {{ (ctrl.status != null
                                        ? ('STATUS.' + ctrl.status)
                                        : 'STATUS.APPLIED') | translate }}
                                      </div>
                                      <p *ngIf="ctrl.status==='FAILED' && getMyIndexData?.expiringStatus !='LICENSE_EXPIRED'"
                                        class="text-decoration-underline cursor-pointer m-0 no-wrap"
                                        (click)="openSendControlPopup(getMyIndexData?.id,ctrl.key,getMyIndexData?.deviceType,getMyIndexData?.deviceName)">
                                        {{ "MANAGEDEVICE.WHYITSFAILED" | translate }}
                                      </p>
                                      <p class="m-0 opacity-50 font-400-12"
                                        *ngIf="(ctrl.key==='RANSOMEWARE' || ctrl.key==='VIRUS' ) && ctrl.val === false && ctrl.onTime != null">
                                        <img src="./assets/images/Info.png" />{{ ctrl.onTime}}
                                      </p>
                                    </ng-container>
                                    <ng-template #naStatus>
                                      <div class="status-disable-text text-center off">{{ 'SETTINGS.NA' | translate }}
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Action Buttons -->
                            <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'" class="button-container ms-4 py-2">
                              <button
                                [disabled]="(getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' && getMyIndexData?.productType !== 'MOBSEC_BASIC') || !isCompatible(getMyIndexData?.buildVersion)"
                                [ngClass]="(getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' && getMyIndexData?.productType !== 'MOBSEC_BASIC') || !isCompatible(getMyIndexData?.buildVersion) ? 'q-invalid-button' : 'bg-orgclr manage-device-control shadow-none'"
                                (click)="managedDeviceControlBtnClick($event, getMyIndexData.id)"
                                class="manage-device-btn">
                                {{ "MANAGEDEVICE.MANAGEDEVICECONTROL" | translate }}
                              </button>
                            </div>

                            <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'" class="button-container ms-4 py-4">
                              <button
                                [disabled]="getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' || parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer)"
                                [ngClass]="getMyIndexData?.expiringStatus === 'LICENSE_EXPIRED' || parseFloat(getMyIndexData?.buildVersion) < parseFloat(DeskCompatibleVer) ? 'q-invalid-button' : 'bg-orgclr manage-device-control shadow-none'"
                                (click)=" managedSystemControlBtnClick(loggedInUserId,getMyIndexData.id)"
                                class="manage-device-btn">
                                {{ "MANAGEDEVICE.MANAGEDEVICECONTROL" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8 mb-3">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getMyIndexData?.deviceName == null
                                      ? "N/A"
                                      : getMyIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getMyIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getMyIndexData.deviceType,
                                                getMyIndexData.id
                                              )
                                            ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getMyIndexData)
                                  ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="removeDevicePopup(getMyIndexData)"
                                  class="q-form-white-submit mb-2 me-3">
                                  {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                                </button></span>
                              <span btn4 *ngIf="
                                  getMyIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                                <button (click)="deactivate(getMyIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                  }}
                                </button></span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>

                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                      <button [disabled]="
                                          getMyIndexData?.productLink == null
                                        " [ngClass]="
                                          getMyIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getMyIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button *ngIf="
                                      getMyIndexData?.expirydays < 90 ||
                                      getMyIndexData?.productName ==
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                  <button *ngIf="
                                      getMyIndexData?.expirydays >= 90 &&
                                      getMyIndexData?.productName !=
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobileview getMyndex -->
        <div class="d-block d-md-none" *ngIf="getMyDeviceData?.length != 0">
          <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample2">
            <div *ngFor="let item of getMyDeviceData; let i = index" class="accordion-item bg-white mb-3">
              <div class="accordion-header mb-0" id="headingOne{{ i + 50 }}">
                <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                  data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i + 50 }}" aria-expanded="false"
                  attr.aria-controls="collapseOne{{ i + 50 }}" (click)="selectedIndex(i, item)">
                  <span class="me-4">
                    <tab-title-inline>
                      <span title1>
                        <div class="d-flex justify-content-between">
                          <div class="q-tab-title ms-0" data-toggle="tooltip" title="{{ item?.deviceName }}">
                            <span *ngIf="item?.productKeyType == 'SYSTEM'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.LAPTOPSM' | translate" alt="" srcset="" height="35px"
                                width="35px" class="me-2" />
                            </span>
                            <span *ngIf="item?.productKeyType == 'MOBILE'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.MBLSM' | translate" class="me-2" alt="" srcset=""
                                height="18px" />
                            </span>
                            {{
                            item?.deviceName == null
                            ? "N/A"
                            : item?.deviceName
                            }}
                          </div>
                        </div>
                      </span>
                    </tab-title-inline>
                    <div class="q-tab-title ms-0" data-toggle="tooltip"
                      title="{{ 'MANAGEDEVICE.THISISDEFAULT' | translate }}" *ngIf="item.default === true">
                      <small class="fw-bold default-clr">
                        <span class="me-4"> </span>{{ "MANAGEDEVICE.THISISDEFAULT" | translate }}
                      </small>
                    </div>
                  </span>
                </button>
              </div>
              <div id="collapse_{{ i + 50 }}" class="accordion-collapse collapse"
                attr.aria-labelledby="headingOne{{ i + 50 }}" data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <div class="mblsecurityStatImg">
                    <div *ngIf="getMyIndexData.securityStatus === 'insecure'">
                      <p class="mt-3 fw-bold">
                        {{ "MANAGEDEVICE.YOURDEVICEISNOTSECURED" | translate }}
                      </p>
                      <p class="text-xl-sm text-lg-xs">
                        {{ getMyIndexData?.lastSyncDate }}
                      </p>
                    </div>
                    <div *ngIf="getMyIndexData.securityStatus === 'secure'">
                      <p class="mt-3 fw-bold">
                        {{ "MANAGEDEVICE.YOURDEVICEISSECURED" | translate }}
                      </p>
                      <p class="text-xl-sm text-lg-xs">
                        {{ getMyIndexData?.lastSyncDate }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                    <hr />
                    <div class="d-flex justify-content-between align-items-center flex-wrap my-4">
                      <div>
                        <h5 class="fw-bold mb-0">
                          {{ "DASHBOARD.DEVICEFEATURES" | translate }}
                        </h5>
                      </div>
                      <div class="org-clr">
                        <span class="mb-0 fs-18 cursor-pointer" (click)="
                            gotoCommands(getMyIndexData.id, 'UPDATE_VIRUS_DB')
                          ">
                          {{ "MANAGEDEVICE.UPDATEVIRUS" | translate
                          }}<span class="gray-clr ms-1">|</span>
                        </span>
                        <span class="mb-0 fs-18 cursor-pointer" (click)="
                            gotoCommands(getMyIndexData.id, 'SYNC_DEVICE')
                          ">
                          {{ "MANAGEDEVICE.SYNCDEVICE" | translate }}
                        </span>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3">
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCATE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getMyIndexData.id, 'TRACE')">
                        <img [src]="'MANAGEDEVICE.LOCATEIMG' | translate" alt="locate.png" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCATE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCK' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getMyIndexData.id, 'BLOCK')">
                        <img src="../../../assets/images/lock.png" alt="lock" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCK" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.WIPE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getMyIndexData.id, 'WIPE')">
                        <img src="../../../assets/images/wipe.png" alt="wipe" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.WIPE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.ANTITHEFT' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                          gotoCommands(getMyIndexData.id, 'ANTITHEFT_SETTINGS')
                        ">
                        <img src="../../../assets/images/anti-theft.png" alt="theft" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.ANTITHEFT" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                          gotoCommands(getMyIndexData.id, 'SCAN_FROM_CLOUD')
                        ">
                        <img src="../../../assets/images/scan.png" alt="scan" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SCANDEVICE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.RINGDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getMyIndexData.id, 'RING_DEVICE')">
                        <img src="../../../assets/images/mng-ringdevice.svg" alt="ring" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.RINGDEVICE" | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- deviceDetails index 1 -->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI === 0">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getMyIndexData?.deviceName == null
                                      ? "N/A"
                                      : getMyIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getMyIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getMyIndexData.deviceType,
                                                getMyIndexData.id
                                              )
                                            ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getMyIndexData)
                                  ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="removeDevicePopup(getMyIndexData)"
                                  class="q-form-white-submit mb-2 me-3">
                                  {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                                </button></span>
                              <span btn4 *ngIf="
                                  getMyIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                                <button (click)="deactivate(getMyIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                  }}
                                </button></span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- licenceDetails index 1-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI === 0">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>
                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                      <button [disabled]="
                                          getMyIndexData?.productLink == null
                                        " [ngClass]="
                                          getMyIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getMyIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button *ngIf="getMyIndexData?.expirydays < 90"
                                    [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeUserRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- deviceDetails index 2 -->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getMyIndexData?.deviceName == null
                                      ? "N/A"
                                      : getMyIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getMyIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getMyIndexData.deviceType,
                                                getMyIndexData.id
                                              )
                                            ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "MANAGEDEVICE.DEVICEOWNER" | translate
                                    }}ss
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getMyIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getMyIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getMyIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getMyIndexData.deviceType,
                                                  getMyIndexData.id
                                                )
                                              ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getMyIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.emailId == null
                                    ? "N/A"
                                    : getMyIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getMyIndexData)
                                  ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="removeDevicePopup(getMyIndexData)"
                                  class="q-form-white-submit mb-2 me-3">
                                  {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                                </button></span>
                              <span btn4 *ngIf="
                                  getMyIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                                <button (click)="deactivate(getMyIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                  }}
                                </button></span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- licenceDetails index 2-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedI && getMyIndexData">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between"
                        [ngClass]="
                          selectedI ? 'border-radius' : 'border-radius'
                        ">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.id,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>

                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                        getMyIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                      <button [disabled]="
                                          getMyIndexData?.productLink == null
                                        " [ngClass]="
                                          getMyIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getMyIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="getMyIndexData?.deviceType == 'SYSTEM'">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productName == null
                                    ? "N/A"
                                    : getMyIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.productKey == null
                                    ? "N/A"
                                    : getMyIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getMyIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getMyIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getMyIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData?.activationDate == null
                                    ? "N/A"
                                    : getMyIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                    getMyIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                  <button *ngIf="
                                      getMyIndexData?.expirydays < 90 ||
                                      getMyIndexData?.productName ==
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                  <button *ngIf="
                                      getMyIndexData?.expirydays >= 90 &&
                                      getMyIndexData?.productName !=
                                        'Quick Heal Total Security'
                                    " [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <!--</div> -->
          </div>
        </div>
      </div>

      <!-- -------------------------------------------------------------------------------------------- -->
      <!-- User Device -->
      <div *ngIf="openUserDeviceContent" id="tabs-profile" role="tabpanel" aria-labelledby="tabs-profile-tab">
        <div class="row bg-white mt-3 mb-5 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
          *ngIf="getUserDeviceData?.length === 0">
          <div class="col-md-12">
            <div class="nodatafounddiv">
              <img [src]="'IMAGES.NORECORDFOUNDIMG' | translate" class="img-fluid" alt="" />
              <h1 class="mt-4">
                <app-main-heading>
                  <span title>{{
                    "MANAGEDEVICE.NODEVICEFOUND" | translate
                    }}</span>
                </app-main-heading>
              </h1>
            </div>
          </div>
        </div>
        <div class="mx-auto w-100 relative d-none d-md-block" *ngIf="getUserDeviceData?.length != 0">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
              <!-- verticle  -->
              <div class="d-flex mt-3 mb-3">
                <div class="col-3">
                  <nav id="">
                    <div
                      class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column px-0 d-flex flex-wrap">
                      <ul class="flex-column min-w-100 d-flex list-unstyled me-3" id="pills-tabVertical">
                        <li *ngFor="let item of allOtherDevices; let i = index" (click)="selectedUserIndex(i, item)"
                          class="align-items-center cursor-pointer bg-white" [ngClass]="
                            selectedI === i
                              ? 'q-vertical-text-user-selected'
                              : 'q-vertical-text-user'
                          ">
                          <div class="device-content" [class.with-banner]=" item?.expiringStatus === 'LICENSE_EXPIRED'">
                            <tab-title-inline>
                              <span title1>
                                <div class="d-flex align-items-center justify-content-center">
                                  <div class="q-tab-title ms-0" style="font-size: 16px" data-toggle="tooltip"
                                    title="{{ item?.deviceName }}">
                                    <span *ngIf="item?.deviceType == 'SYSTEM'">
                                      <img [src]="
                                        'MANAGEDEVICE.LAPTOPSM' | translate
                                      " alt="" srcset="" height="35px" width="35px" class="me-2" />
                                    </span>
                                    <span *ngIf="item?.deviceType == 'MOBILE'">
                                      <img src="./assets/images/MobileIcon.svg" class="me-2" alt="" srcset=""
                                        height="35px" />
                                    </span>
                                    {{
                                    item?.deviceName == null
                                    ? "N/A"
                                    : item?.deviceName.length > 20
                                    ? item?.deviceName.slice(0, 20) + "..."
                                    : item?.deviceName
                                    }}
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2" *ngIf="
                                    (item &&
                                      item?.securityStatus === 'insecure' &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRED') ||
                                    (item &&
                                      item?.detected &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRED')
                                  ">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{ "MANAGEDEVICE.ALERT" | translate }}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2" *ngIf="
                                    (item &&
                                      item?.securityStatus === 'secure' &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRING_SOON') ||
                                    (item &&
                                      item?.detected === true &&
                                      item?.expiringStatus ===
                                        'LICENSE_EXPIRING_SOON')
                                  ">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "LICENSESUMMARY.ABOUTTOEXPIRE" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div class="d-flex align-items-center gap-2 mt-2 mb-2" *ngIf="
                                    (item &&
                                      item?.securityStatus === 'secure' &&
                                      item?.licenseValidityDate ===
                                        'Free version') ||
                                    (item &&
                                      item?.detected === true &&
                                      item?.licenseValidityDate ===
                                        'Free version')
                                  ">
                                    <div class="badge badge-pill status-text-recommendations ms-5">
                                      {{
                                      "LICENSESUMMARY.BUYPREMIUM" | translate
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div>

                                  <div class="badge badge-pill status-text-recommendations ms-5">
                                    Dvice control stopped working
                                  </div>

                                </div>

                                <div class="d-flex align-items-center align-items-center gap-2 mt-2 mb-2"
                                  [ngStyle]="{'margin-top': hasAnyTag(item) ? '-23px' : '-10px'}">
                                  <div class="d-flex align-items-center ms-5">
                                    <img src="./assets/images/User.svg" style="margin-right:5px;" alt="" srcset=""
                                      height="12px" />
                                    <span style="color: #526B77; font-size:12px; font-weight:400;">
                                      {{item?.currentUserName || 'Unknown User' }}
                                    </span>
                                  </div>
                                  <div>
                                    <span class="badge" style="margin-right:4rem;" data-toggle="tooltip"
                                      title="{{getRoleLabel(item?.userRole)}}" [style.color]="privacyStatusClr"
                                      [style.background-color]="privacyStatusBg">{{
                                      getRoleLabel(item?.userRole) == null ? "" : getRoleLabel(item?.userRole)
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </span>
                            </tab-title-inline>
                          </div>
                          <div *ngIf="item?.expiringStatus === 'LICENSE_EXPIRED'" class="license-expired-banner">
                            {{ "MANAGEDEVICE.LICENSEEXP" | translate }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                <div class="col-9">
                  <div class="p-4 qh-vertical-content mb-4 border-radius">
                    <div class="mt-3 fw-bold border-device mb-3"
                      *ngIf="getUserIndexData && getUserIndexData?.expiringStatus === 'LICENSE_EXPIRED'">
                      <div class="d-flex align-items-center justify-content-between">

                        <div class="d-flex align-items-center">
                          <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
                          <p class="text-align-left-notification ms-2 mb-0">
                            {{ "MANAGEDEVICE.LICENSEEXP" | translate }}
                          </p>
                        </div>

                        <button class="bg-orgclr submit-btn-renew renew-btn" (click)="checkBeforeUserRenew()"
                          [ngStyle]="{ width: selectedLanguage !== 'en' ? 'auto' : 'unset' }">
                          {{ "MANAGEDEVICE.RENEW" | translate }}
                        </button>
                      </div>
                    </div>

                    <<div class="d-flex flex-wrap mb-3 mt-4 align-items-center py-2">
                      <p class="left d-flex align-items-center mb-0 me-3">
                        {{ "MANAGEDEVICE.DEVICECOMMANDS" | translate }}
                      </p>

                      <p class="myElement text-align-left cursor-pointer d-flex align-items-center mb-0 me-3"
                        (click)="deviceCommandsPopup()">
                        <img src="assets/images/OrangeInfo.png" alt="" class="me-1" />
                        <span class="text-decoration-underline">
                          {{ "MANAGEDEVICE.HOWSTHISWORK" | translate }}
                        </span>
                      </p>

                      <p class="right d-flex align-items-center mb-0 ms-auto" *ngIf="getUserIndexData?.lastSyncDate">
                        <img [src]="'DASHBOARD.VECTORROUND' | translate" width="18" height="21" alt="" class="me-1" />
                        {{ getUserIndexData?.lastSyncDate }}
                      </p>
                  </div>


                  <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                    <div class="d-flex flex-wrap mb-3">
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            sendCommand(getUserIndexData.id, 'SCAN_FROM_CLOUD')
                          ">
                        <img src="../../../assets/images/scan.png" alt="scan" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SCANDEVICE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SYNCDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            openSyncScoreModal(
                              getUserIndexData.id,
                              'SYNC_DEVICE'
                            )
                          ">
                        <img [src]="'DASHBOARD.GROUPSYNC' | translate" alt="sycn" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SYNCDEVICE" | translate }}
                        </div>
                      </div>

                      <!-- sync initiated pop up -->
                      <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto"
                        id="LockPopup" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
                        aria-hidden="true">
                        <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                          <div
                            class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
                            <ng-container *ngIf="!isLock">
                              <div class="mt-4">
                                <img src="./assets/images/sync.svg" alt="" class="mx-auto" />
                              </div>
                              <h4 class="q-modal-heading mt-2 fw-bold">
                                {{ "MANAGEDEVICE.SYNCINITIATED" | translate }}
                              </h4>
                              <div class="text-center mb-4 mt-3 d-flex justify-content-center">
                                <div class="me-3">
                                  <!-- (click)="isLockClicked()" -->
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.RINGDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            sendCommand1(getUserIndexData.id, 'RING_DEVICE')
                          ">
                        <img [src]="'MANAGEDEVICE.RINGIMG' | translate" alt="ring" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.RINGDEVICE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCATE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getUserIndexData.id, 'TRACE')">
                        <img [src]="'MANAGEDEVICE.LOCATEIMG' | translate" alt="locate.png" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCATE" | translate }}
                        </div>
                      </div>
                      <div *ngIf="!lockData" data-toggle="tooltip" i18n-title
                        title="{{ 'MANAGEDEVICE.LOCK' | translate }}" class="syncdevice-card cursor-pointer"
                        (click)="sendCommand4()">
                        <img [src]="'MANAGEDEVICE.LOCKSMIMG' | translate" alt="lock" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCK" | translate }}
                        </div>
                      </div>
                      <div *ngIf="lockData" data-toggle="tooltip" i18n-title
                        title="{{ 'MANAGEDEVICE.UNLOCK' | translate }}" class="syncdevice-card cursor-pointer"
                        (click)="sendCommand5(getUserIndexData.id, 'UNLOCK')">
                        <img [src]="'MANAGEDEVICE.UNLOCKSMIMG' | translate" alt="unLock" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.UNLOCK" | translate }}
                        </div>
                      </div>

                      <div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto"
                        id="LockPopup1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                        aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                          <div
                            class="modal-content border-none px-4 shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
                            <ng-container *ngIf="!isLock">
                              <h4 class="q-modal-heading mt-4 fw-bold">
                                {{ "SUCESSMESSAGE.LOCKDEVICE" | translate }}
                              </h4>
                              <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                <span (click)="closeModal1()"><img src="./assets/images/otpCancel.svg" alt=""
                                    class="ms-xl-4" /></span>
                              </div>
                              <div class="mt-2">
                                <img src="./assets/images/LockDevice1.svg" alt="" class="mx-auto" />
                              </div>
                              <p class="lockBlack-clr text-change mt-4" style="font-size: 16px">
                                {{
                                "SUCESSMESSAGE.DOYOUWANTTOLOCK" | translate
                                }}
                              </p>
                              <ng-container *ngIf="errorMessage">
                                <p class="errMessage" style="margin: 10px 90px">
                                  {{ errorMessage }}
                                </p>
                              </ng-container>
                              <div class="text-center mb-4 d-flex justify-content-center mt-4">
                                <div class="me-3">
                                  <button type="button" class="submit-btn bg-orgclr" (click)="
                                        sendCommand5(
                                          getUserIndexData.id,
                                          'BLOCK'
                                        )
                                      ">
                                    {{ "MANAGEDEVICE.YES" | translate }}
                                  </button>
                                </div>
                                <div class="">
                                  <button type="button" class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal"
                                    (click)="closeModal()">
                                    {{ "LOGIN.NO" | translate }}
                                  </button>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="isLock">
                              <div class="mt-4">
                                <img src="./assets/images/SuccessLock.svg" alt="" class="mx-auto" />
                              </div>
                              <h5 *ngIf="Locked" class="fw-bold mt-4 deleteUser">
                                {{
                                "SUCESSMESSAGE.DEVICELOCKSUCCESSFULLY"
                                | translate
                                }}
                              </h5>
                              <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                <span (click)="closeModal1()"><img src="./assets/images/otpCancel.svg" alt=""
                                    class="ms-xl-4" /></span>
                              </div>
                              <h5 *ngIf="!Locked" class="fw-bold mt-4 deleteUser">
                                {{
                                "SUCESSMESSAGE.DEVICEUNLOCKSUCCESSFULLY"
                                | translate
                                }}
                              </h5>
                              <div data-toggle="tooltip" i18n-title title="{{
                                    'MANAGEDEVICE.LOCATE' | translate
                                  }}" class="cursor-pointer" (click)="
                                    gotoCommands(getMyIndexData.id, 'TRACE')
                                  ">
                                <h5 style="
                                      color: #f16522;
                                      border-bottom: 1px solid #f16522;
                                      display: inline-block;
                                      padding-bottom: 2px;
                                    ">
                                  {{ "MANAGEDEVICE.VIEWLOCATION" | translate}}
                                </h5>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.WIPE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="sendCommand2()">
                        <img [src]="'MANAGEDEVICE.WIPEIMG' | translate" alt="wipe" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.WIPE" | translate }}
                        </div>
                      </div>

                      <!--  pop up for wipe-->
                      <div class="modal mx-auto fade" id="WipePopup" data-bs-backdrop="static" data-bs-keyboard="false"
                        tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                          <div
                            class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none">
                            <ng-container *ngIf="!isLock">
                              <h4 class="q-modal-heading mt-4 fw-bold">
                                {{ "SUCESSMESSAGE.WIPEDATA" | translate }}
                              </h4>
                              <div style="
                                    position: absolute;
                                    top: 25px;
                                    right: 25px;
                                  ">
                                <span (click)="closeModal2()"><img src="./assets/images/otpCancel.svg" alt=""
                                    class="ms-xl-4" /></span>
                              </div>
                              <div class="mt-2">
                                <img src="./assets/images/WipeData.svg" alt="" class="mx-auto" />
                              </div>

                              <p class="lockBlack-clr text-change mt-4" style="font-size: 16px">
                                {{ "MANAGEDEVICE.WIPEALLDATAS" | translate }}
                                {{ deviceName }}
                              </p>

                              <ng-container *ngIf="errorMessage">
                                <p class="errMessage" style="margin: 10px 90px">
                                  {{ errorMessage }}
                                </p>
                              </ng-container>
                              <div class="text-center mb-4 d-flex justify-content-center mt-4">
                                <div class="me-3">
                                  <button type="button" class="submit-btn bg-orgclr" (click)="
                                        sendCommand3(
                                          getUserIndexData.id,
                                          'WIPE'
                                        )
                                      ">
                                    {{ "MANAGEDEVICE.YES" | translate }}
                                  </button>
                                </div>
                                <div class="">
                                  <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeModal()">
                                    {{ "LOGIN.NO" | translate }}
                                  </button>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="isLock">
                              <div class="mt-4">
                                <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
                              </div>
                              <h5 class="q-modal-heading mt-4 deleteUser">
                                {{
                                "SUCESSMESSAGE.WIPEDATACOMMAND" | translate
                                }}
                              </h5>
                              <div class="text-center">
                                <div class="text-lg font-normal">
                                  <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4"
                                    data-bs-dismiss="modal">
                                    {{ "SIGNUP.DONE" | translate }}
                                  </button>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.ANTITHEFT' | translate }}"
                        class="antiTheft-card cursor-pointer" (click)="sendCommand6()">
                        <img [src]="'DASHBOARD.VECTOR' | translate" class="corner-image" width="50" height="50"
                          viewBox="0 0 50 50" alt="theft" />
                        <img [src]="'MANAGEDEVICE.ANTITHEFTIMG' | translate" alt="theft" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.ANTITHEFT" | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="getUserIndexData?.deviceType == 'SYSTEM'">
                    <div class="d-flex flex-wrap mb-3">
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" [class.btnDisabled]="isScanButtonDisabled" (click)="
                            openSyncScoreModalnew(
                              getUserIndexData.id,
                              'SCAN_FROM_CLOUD',
                              getUserIndexData?.deviceType,
                              false
                            )
                          ">
                        <!-- (click)="(getMyIndexData.id,'SCORE')" -->
                        <img [src]="'MANAGEDEVICE.SCANIMG' | translate" alt="scan" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SCAN" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SYNC' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'UPDATE_ALL_DETAILS');
                              sendDesktopCommand(getMyIndexData.id,'SYSTEM', 'SCORE') ">
                        <img [src]="'MANAGEDEVICE.SCOREIMG' | translate" alt="scan" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SYNC" | translate }}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="isScanButtonDisabled">{{ "MANAGEDEVICE.SCANDISABLEMSG" | translate }}</div>
                  </div>

                  <div *ngFor="let item of tabsData; let i = index" class="modal mx-auto fade" id="AntiTheftPopup"
                    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
                      <div
                        class="modal-content border-none shadow-lg px-4 relative pointer-events-auto rounded-25 bg-white outline-none"
                        style="width: 683px">
                        <div>
                          <h4 class="q-heading mt-4">
                            {{ "SETTINGS.ANTITHEFT" | translate }}
                          </h4>

                          <div style="position: absolute; top: 25px; right: 25px">
                            <span (click)="closeModal3()"><img src="./assets/images/otpCancel.svg" alt=""
                                class="ms-xl-4" /></span>
                          </div>
                        </div>

                        <div>
                          <p class="lockBlack-clr text-change">
                            {{ "MANAGEDEVICE.ANTITHEFTCOMMAND" | translate }}
                          </p>
                        </div>

                        <div class="p-4" [ngClass]="
                              selectedI === 0
                                ? 'content-border-radius'
                                : 'rounded-border-radius'
                            ">
                          <div class="d-flex justify-content-between align-items-center flex-wrap"></div>
                          <div class="d-flex flex-wrap mb-3 justify-content-center" style="width: 600px">
                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getUserIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                style="width: 126px" (click)="
                                    selectedIndex1(getUserIndexData.id, 'PHOTO')
                                  " (click)="
                                    sendCommand7(
                                      getUserIndexData.id,
                                      'ANTITHEFT_SETTINGS'
                                    )
                                  ">
                                <img src="./assets/images/TakePicture.png"
                                  alt='{{ "MANAGEDEVICE.TAKEPICTUR" | translate }}' class="button-image" />
                                <div class="mt-1 font-12">
                                  {{ "MANAGEDEVICE.TAKEPICTUR" | translate }}</div>
                              </div>
                            </ng-container>

                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getUserIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                style="width: 126px" (click)="
                                    selectedIndex1(getUserIndexData.id, 'AUDIO')
                                  " (click)="
                                    sendCommand7(
                                      getUserIndexData.id,
                                      'ANTITHEFT_SETTINGS'
                                    )
                                  ">
                                <img src="./assets/images/microphone.png"
                                  alt='{{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}' class="button-image" />
                                <div class="mt-1 font-12">
                                  {{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}</div>
                              </div>
                            </ng-container>

                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate !=
                                      'Free version' &&
                                    getUserIndexData?.expiringStatus !==
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card antiTheft-card-border cursor-pointer"
                                style="width: 126px" (click)="
                                    selectedIndex1(getUserIndexData.id, 'VIDEO')
                                  " (click)="
                                    sendCommand7(
                                      getUserIndexData.id,
                                      'ANTITHEFT_SETTINGS'
                                    )
                                  ">
                                <img src="./assets/images/TakeVideo.png"
                                  alt='{{ "MANAGEDEVICE.RECORDVIDEO" | translate }}' class="button-image" />
                                <div class="mt-1 font-12">
                                  {{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}</div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="getUserIndexData?.osVersion <= 9">
                              <div class="row">
                                <form [formGroup]="autoDialForm">
                                  <div *ngIf="
                                        getUserIndexData?.licenseValidityDate !=
                                          'Free version' &&
                                        getUserIndexData?.expiringStatus !==
                                          'LICENSE_EXPIRED'
                                      " data-toggle="tooltip" [ngClass]="{
                                        'antiTheft-card antiTheft-card-border cursor-pointer':
                                          !autodial,
                                        ' actives cursor-pointer': autodial
                                      }" style="width: 126px" (click)="
                                        selectedIndex1(
                                          getUserIndexData.id,
                                          'CALL'
                                        )
                                      ">
                                    <img src="./assets/images/AutoDial1.svg" alt="Auto Dial" class="button-image" />
                                  </div>
                                </form>
                              </div>
                            </ng-container>

                            <!-- free vesrion disable commands-->

                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getUserIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  ">
                                <div data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                  <img src="./assets/images/TakePicture.png"
                                    alt='{{ "MANAGEDEVICE.TAKEPICTUR" | translate }}' />
                                  <div class="mt-1 font-12">
                                    {{ "MANAGEDEVICE.TAKEPICTUR" | translate }}
                                  </div>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getUserIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                <img src="./assets/images/microphone.png"
                                  alt='{{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}' />
                                <div class="mt-1 font-12">
                                  {{ "MANAGEDEVICE.AUTOCAPTUREAUDIO" | translate }}</div>
                              </div>
                            </ng-container>

                            <ng-container>
                              <div *ngIf="
                                    getUserIndexData?.licenseValidityDate ===
                                      'Free version' ||
                                    getUserIndexData?.expiringStatus ===
                                      'LICENSE_EXPIRED'
                                  " data-toggle="tooltip" class="antiTheft-card opacity-50" style="width: 126px">
                                <img src="./assets/images/TakeVideo.png"
                                  alt='{{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}' />
                                <div class="mt-1 font-12">
                                  {{ "MANAGEDEVICE.AUTOCAPTUREVIDEO" | translate }}</div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="getUserIndexData?.osVersion <= 9">
                              <div class="row">
                                <form [formGroup]="autoDialForm">
                                  <div *ngIf="
                                        getUserIndexData?.licenseValidityDate ===
                                          'Free version' ||
                                        getUserIndexData?.expiringStatus ===
                                          'LICENSE_EXPIRED'
                                      " data-toggle="tooltip" class="antiTheft-card" style="width: 126px">
                                    <img src="./assets/images/AutoDial.png" alt="Auto Dial" />
                                  </div>
                                </form>
                              </div>
                            </ng-container>
                            <div *ngIf="
                                  getUserIndexData?.licenseValidityDate ===
                                  'Free version'
                                ">
                              <p class="lockBlack-clr text-change mt-2">
                                {{
                                "MANAGEDEVICE.UPGRADETOACCESS" | translate
                                }}
                              </p>

                              <button type="button" class="bg-orgclr submit-btn shadow-none"
                                (click)="checkBeforeUserRenew()">
                                {{ "LICENSESUMMARY.UPGRADE" | translate }}
                              </button>
                            </div>
                            <div *ngIf="
                                  getUserIndexData?.expiringStatus ===
                                  'LICENSE_EXPIRED'
                                ">
                              <p class="lockBlack-clr text-change mt-2">
                                {{ "MANAGEDEVICE.RENEWTOACCESS" | translate }}
                              </p>
                              <button type="button" class="bg-orgclr submit-btn shadow-none"
                                (click)="checkBeforeUserRenew()">
                                {{ "LICENSESUMMARY.RENEW" | translate }}
                              </button>
                            </div>
                            <div class="auto-dial mt-3" *ngIf="autodial">
                              <div class="mt-4"></div>
                              <div class="act-text-line mt-3 px-5">
                                {{ "MANAGEDEVICE.AUTODIALDESC" | translate }}
                              </div>
                              <div class="act-text-line mt-3 px-5">
                                <label for="name" class="q-form-label">{{ "MANAGEDEVICE.ENTERMOBN" | translate
                                  }}<span class="text-danger">*</span></label>
                              </div>
                              <div class="d-flex px-5 mt-2 w-100">
                                <form [formGroup]="autoDialForm">
                                  <ngx-intl-tel-input [cssClass]="'form-control q-form-control'"
                                    [onlyCountries]="['in']" [enableAutoCountrySelect]="false"
                                    [enablePlaceholder]="true" [searchCountryFlag]="true"
                                    customPlaceholder="Enter Your Mobile Number" [searchCountryField]="[
                                        SearchCountryField.Iso2,
                                        SearchCountryField.Name
                                      ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                    [maxLength]="15" [phoneValidation]="true" name="phone" type="number"
                                    formControlName="mobileNo" (keydown)="removeSpace1($event)"
                                    (ngModelChange)="onFocusOutMobile($event)"></ngx-intl-tel-input>

                                  <ng-container *ngIf="mobileNoWrong">
                                    <p class="errMessage">
                                      {{
                                      "MANAGEDEVICE.MINANDMAX8" | translate
                                      }}
                                    </p>
                                  </ng-container>

                                  <ng-container *ngIf="errorMessage">
                                    <p class="errMessage">
                                      {{ errorMessage }}
                                    </p>
                                  </ng-container>
                                </form>

                                <button class="newrenew-button submit-btn-renew bg-orgclr ms-3" type="submit" (click)="
                                      sendCommand7(
                                        getUserIndexData.id,
                                        'ANTITHEFT_SETTINGS'
                                      )
                                    ">
                                  {{ "MANAGEDEVICE.AUTODIAL" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-0 mb-4 qh-vertical-content border-radius">
                  <ng-container *ngIf="selectedUsersIndex === 0">
                    <div id="accordionDevice"
                      class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                      <div class="accordion-item-device bg-white">
                        <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                          aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                          {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                        </button>
                        <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                          <div class="col-sm-8">
                            <div class="d-flex flex-wrap mt-3">
                              <div class="col-4">
                                {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                              </div>
                              <div class="q-tab-content-desc">
                                <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                  <div class="text-truncate">
                                    {{
                                    getUserIndexData?.deviceName == null
                                    ? "N/A"
                                    : getUserIndexData?.deviceName
                                    }}
                                  </div>
                                  <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getUserIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                </div>
                                <div *ngIf="enableMyDeviceNameInput">
                                  <div class="form-group">
                                    <div class="d-flex">
                                      <div>
                                        <input type="text" class="form-control q-form-control me-3"
                                          [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                      </div>
                                      <div>
                                        <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getUserIndexData.deviceType,
                                                getUserIndexData.id
                                              )
                                            ">
                                          {{ "MANAGEDEVICE.UPDATE" | translate }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.currentUserName ==
                                      null
                                      ? "N/A"
                                      : getUserIndexData?.currentUserName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyCurrentUserNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="updateName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.PHONENO" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.mobileNo == null
                                  ? "N/A"
                                  : getUserIndexData?.mobileNo
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.EMAILID" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.emailId == null
                                  ? "N/A"
                                  : getUserIndexData?.emailId
                                  }}
                                </div>
                              </div>
                            </div>

                            <div *ngIf="getUserIndexData?.deviceType == 'SYSTEM'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.currentUserName ==
                                      null
                                      ? "N/A"
                                      : getUserIndexData?.currentUserName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyCurrentUserNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="updateName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.PHONENO" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.mobileNo == null
                                  ? "N/A"
                                  : getUserIndexData?.mobileNo
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.EMAILID" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.emailId == null
                                  ? "N/A"
                                  : getUserIndexData?.emailId
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-12 mb-3 mt-3">
                            <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getUserIndexData)
                                  ">
                                {{
                                "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                }}
                              </button>
                            </span>

                            <span btn3>
                              <button (click)="removeDevicePopup(getUserIndexData)"
                                class="q-form-white-submit mb-2 me-3">
                                {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                              </button></span>
                            <span btn4 *ngIf="
                                  getUserIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                              <button (click)="deactivate(getUserIndexData)" class="q-form-white-submit mb-2">
                                {{
                                "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                }}
                              </button></span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="p-0 mb-4 qh-vertical-content border-radius">
                  <ng-container *ngIf="selectedUsersIndex === 0">
                    <div id="accordionDevice"
                      class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                      <div class="accordion-item-device bg-white">
                        <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                          aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                          (click)="toggleLicenseContent()">
                          {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                        </button>
                        <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                          <div class="col-sm-8">
                            <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTNAME" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productName == null
                                  ? "N/A"
                                  : getUserIndexData?.productName
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTKEY" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productKey == null
                                  ? "N/A"
                                  : getUserIndexData?.productKey
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.BUILDVERSION" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.buildVersion == null
                                  ? "N/A"
                                  : getUserIndexData?.buildVersion
                                  }}
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.LICENSEVALIDITY"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc d-flex align-items-center">
                                  {{
                                  getUserIndexData?.licenseValidityDate ==
                                  null
                                  ? "N/A"
                                  : getUserIndexData?.licenseValidityDate
                                  }}
                                  <span class="ms-1 cursor-pointer"
                                    onclick="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                    <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                  </span>
                                  <span
                                    (click)="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                    <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                      {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                  </span>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.ACTIVATIONDATE"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.activationDate == null
                                  ? "N/A"
                                  : getUserIndexData?.activationDate
                                  }}
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.AUTORENEW" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData.autoRenewal == 1
                                    ? ("MANAGEDEVICE.YES" | translate)
                                    : ("MANAGEDEVICE.NO" | translate)
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4" style="width: 120px" *ngIf="
                                    getUserIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                <button [disabled]="!getMyIndexData?.productLink" [ngClass]="
                                      getMyIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                              </div>
                              <div class="d-flex mt-4 mb-3">
                                <div class="q-tab-content-title">
                                  <div *ngIf="
                                        getUserIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                    <button [disabled]="
                                          getUserIndexData?.productLink == null
                                        " [ngClass]="
                                          getUserIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getUserIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                      {{
                                      "LICENSESUMMARY.BUYPREMIUM"
                                      | translate
                                      }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getUserIndexData?.deviceType == 'SYSTEM'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTNAME" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productName == null
                                  ? "N/A"
                                  : getUserIndexData?.productName
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTKEY" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productKey == null
                                  ? "N/A"
                                  : getUserIndexData?.productKey
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.BUILDVERSION" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.buildVersion == null
                                  ? "N/A"
                                  : getUserIndexData?.buildVersion
                                  }}
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.LICENSEVALIDITY"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc d-flex align-items-center">
                                  {{
                                  getUserIndexData?.licenseValidityDate ==
                                  null
                                  ? "N/A"
                                  : getUserIndexData?.licenseValidityDate
                                  }}

                                  <span class="ms-1 cursor-pointer"
                                    onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                    <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                  </span>
                                  <span
                                    (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                    <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                      {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                  </span>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.ACTIVATIONDATE"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.activationDate == null
                                  ? "N/A"
                                  : getUserIndexData?.activationDate
                                  }}
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.AUTORENEW" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData.autoRenewal == 1
                                    ? ("MANAGEDEVICE.YES" | translate)
                                    : ("MANAGEDEVICE.NO" | translate)
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div class="mt-4" style="width: 120px" *ngIf="
                                    getUserIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                <button *ngIf="
                                      getMyIndexData?.expirydays < 90 ||
                                      getMyIndexData?.productName ==
                                        'Quick Heal Total Security'
                                    " [disabled]="!getUserIndexData?.productLink" [ngClass]="
                                      getUserIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeUserRenew()">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                                <button *ngIf="
                                      getMyIndexData?.expirydays >= 90 &&
                                      getMyIndexData?.productName !=
                                        'Quick Heal Total Security'
                                    " [disabled]="!getUserIndexData?.productLink" [ngClass]="
                                      getUserIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="
                                      openMyIndexRenewLicense(getUserIndexData)
                                    ">
                                  {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="p-0 mb-4 qh-vertical-content border-radius">
                  <ng-container *ngIf="selectedUsersIndex && getUserIndexData">
                    <div id="accordionDevice"
                      class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                      <div class="accordion-item-device bg-white">
                        <button [ngClass]="
                              expanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                          aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                          {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                        </button>
                        <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                          <div class="col-sm-8">
                            <div class="d-flex flex-wrap mt-3">
                              <div class="col-4">
                                {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                              </div>
                              <div class="q-tab-content-desc">
                                <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                  <div class="text-truncate">
                                    {{
                                    getUserIndexData?.deviceName == null
                                    ? "N/A"
                                    : getUserIndexData?.deviceName
                                    }}
                                  </div>
                                  <span><img class="cursor-pointer" [src]="
                                          'MANAGEDEVICE.PENIMG' | translate
                                        " alt="" (click)="
                                          openDeviceInput(
                                            getUserIndexData.id,
                                            'MYDEVICEUSERNAME'
                                          )
                                        " /></span>
                                </div>
                                <div *ngIf="enableMyDeviceNameInput">
                                  <div class="form-group">
                                    <div class="d-flex">
                                      <div>
                                        <input type="text" class="form-control q-form-control me-3"
                                          [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                      </div>
                                      <div>
                                        <button type="button" class="q-form-white-submit" (click)="
                                              updateDevice(
                                                getUserIndexData.deviceType,
                                                getUserIndexData.id
                                              )
                                            ">
                                          {{ "MANAGEDEVICE.UPDATE" | translate }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "MANAGEDEVICE.DEVICEOWNER" | translate
                                  }}ss
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.currentUserName ==
                                      null
                                      ? "N/A"
                                      : getUserIndexData?.currentUserName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyCurrentUserNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="updateName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.PHONENO" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.mobileNo == null
                                  ? "N/A"
                                  : getUserIndexData?.mobileNo
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.EMAILID" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.emailId == null
                                  ? "N/A"
                                  : getUserIndexData?.emailId
                                  }}
                                </div>
                              </div>
                            </div>

                            <div *ngIf="getUserIndexData?.deviceType == 'SYSTEM'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICEOWNER" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.currentUserName ==
                                      null
                                      ? "N/A"
                                      : getUserIndexData?.currentUserName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyCurrentUserNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="updateName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateUserName(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.PHONENO" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.mobileNo == null
                                  ? "N/A"
                                  : getUserIndexData?.mobileNo
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.EMAILID" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.emailId == null
                                  ? "N/A"
                                  : getUserIndexData?.emailId
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-12 mb-3 mt-3">
                            <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                    loggedInUser.roleType ==
                                      CommonEnum.SUPER_ADMIN ||
                                    loggedInUser.roleType == CommonEnum.ADMIN
                                  " (click)="
                                    openTransferOwnershipModal(getUserIndexData)
                                  ">
                                {{
                                "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate
                                }}
                              </button>
                            </span>

                            <span btn3>
                              <button (click)="removeDevicePopup(getUserIndexData)"
                                class="q-form-white-submit mb-2 me-3">
                                {{ "MANAGEDEVICE.REMOVEDEVICE" | translate }}
                              </button></span>
                            <span btn4 *ngIf="
                                  getUserIndexData?.productKeyType ===
                                  'FAMILY_PACK'
                                ">
                              <button (click)="deactivate(getUserIndexData)" class="q-form-white-submit mb-2">
                                {{
                                "MANAGEDEVICE.DEACTIVSTEDEVICE" | translate
                                }}
                              </button></span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="p-0 mb-4 qh-vertical-content border-radius">
                  <ng-container *ngIf="selectedUsersIndex && getUserIndexData">
                    <div id="accordionDevice"
                      class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between"
                      [ngClass]="
                          selectedUsersIndex ? 'border-radius' : 'border-radius'
                        ">
                      <div class="accordion-item-device bg-white">
                        <button [ngClass]="
                              licenseExpanded
                                ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                            " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                          aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                          (click)="toggleLicenseContent()">
                          {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                        </button>
                        <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                          <div class="col-sm-8">
                            <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTNAME" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productName == null
                                  ? "N/A"
                                  : getUserIndexData?.productName
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTKEY" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productKey == null
                                  ? "N/A"
                                  : getUserIndexData?.productKey
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.BUILDVERSION" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.buildVersion == null
                                  ? "N/A"
                                  : getUserIndexData?.buildVersion
                                  }}
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.LICENSEVALIDITY"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc d-flex align-items-center">
                                  {{
                                  getUserIndexData?.licenseValidityDate ==
                                  null
                                  ? "N/A"
                                  : getUserIndexData?.licenseValidityDate
                                  }}

                                  <span class="ms-1 cursor-pointer"
                                    onclick="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                    <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                  </span>
                                  <span
                                    (click)="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                    <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                      {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                  </span>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.ACTIVATIONDATE"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.activationDate == null
                                  ? "N/A"
                                  : getUserIndexData?.activationDate
                                  }}
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.AUTORENEW" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData.autoRenewal == 1
                                    ? ("MANAGEDEVICE.YES" | translate)
                                    : ("MANAGEDEVICE.NO" | translate)
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div class="mt-4" style="width: 120px" *ngIf="
                                    getUserIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                <button [disabled]="!getUserIndexData?.productLink" [ngClass]="
                                      getUserIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeRenew()">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                              </div>

                              <div class="d-flex mt-4 mb-3">
                                <div class="q-tab-content-title">
                                  <div *ngIf="
                                        getUserIndexData?.licenseValidityDate ===
                                        'Free version'
                                      ">
                                    <button [disabled]="
                                          getUserIndexData?.productLink == null
                                        " [ngClass]="
                                          getUserIndexData?.productLink == null
                                            ? 'q-invalid-button me-3'
                                            : 'q-form-white-submit cursor-pointer me-3'
                                        " (click)="
                                          openMyIndexRenewLicense(
                                            getUserIndexData,
                                            'PREMIUM'
                                          )
                                        ">
                                      {{
                                      "LICENSESUMMARY.BUYPREMIUM"
                                      | translate
                                      }}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getUserIndexData?.deviceType == 'SYSTEM'">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTNAME" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productName == null
                                  ? "N/A"
                                  : getUserIndexData?.productName
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.PRODUCTKEY" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.productKey == null
                                  ? "N/A"
                                  : getUserIndexData?.productKey
                                  }}
                                </div>
                              </div>

                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.BUILDVERSION" | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.buildVersion == null
                                  ? "N/A"
                                  : getUserIndexData?.buildVersion
                                  }}
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.LICENSEVALIDITY"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc d-flex align-items-center">
                                  {{
                                  getUserIndexData?.licenseValidityDate ==
                                  null
                                  ? "N/A"
                                  : getUserIndexData?.licenseValidityDate
                                  }}

                                  <span class="ms-1 cursor-pointer"
                                    onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                    <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                  </span>
                                  <span
                                    (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                    <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                      {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                  </span>
                                </div>
                              </div>
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{
                                  "LICENSESUMMARY.ACTIVATIONDATE"
                                  | translate
                                  }}
                                </div>
                                <div class="q-tab-content-desc">
                                  {{
                                  getUserIndexData?.activationDate == null
                                  ? "N/A"
                                  : getUserIndexData?.activationDate
                                  }}
                                </div>
                              </div>

                              <div *ngIf="getMyIndexData">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.AUTORENEW" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getMyIndexData.autoRenewal == 1
                                    ? ("MANAGEDEVICE.YES" | translate)
                                    : ("MANAGEDEVICE.NO" | translate)
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div class="mt-4" style="width: 120px" *ngIf="
                                    getUserIndexData?.licenseValidityDate !==
                                    'Free version'
                                  ">
                                <button *ngIf="
                                      getMyIndexData?.expirydays < 90 ||
                                      getMyIndexData?.productName ==
                                        'Quick Heal Total Security'
                                    " [disabled]="!getUserIndexData?.productLink" [ngClass]="
                                      getUserIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="checkBeforeUserRenew()">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                                <button *ngIf="
                                      getMyIndexData?.expirydays >= 90 &&
                                      getMyIndexData?.productName !=
                                        'Quick Heal Total Security'
                                    " [disabled]="!getUserIndexData?.productLink" [ngClass]="
                                      getUserIndexData?.productLink == null
                                        ? 'q-invalid-button px-4 w-100'
                                        : 'submit-btn bg-orgclr w-100'
                                    " (click)="
                                      openMyIndexRenewLicense(getUserIndexData)
                                    ">
                                  {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobileview userIndex -->
      <div class="d-block d-md-none" *ngIf="getUserDeviceData?.length != 0">
        <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample2">
          <div *ngFor="let user of getUserDeviceData; let j = index">
            <div>
              <strong>{{ user.name }} ({{ user.myUserDeviceList?.length }})</strong>
            </div>

            <div *ngFor="let item of user.myUserDeviceList; let i = index" class="accordion-item bg-white mb-3">
              <div class="accordion-header mb-0" id="headingOne{{ i + 50 }}">
                <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                  data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i + 50 }}" aria-expanded="false"
                  attr.aria-controls="collapseOne{{ i + 50 }}" (click)="selectedUserIndex(i, item)">
                  <span class="me-4">
                    <tab-title-inline>
                      <span title1>
                        <div class="d-flex justify-content-between">
                          <div class="q-tab-title ms-0" data-toggle="tooltip" title="{{ item?.deviceName }}">
                            <span *ngIf="item?.productKeyType == 'SYSTEM'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.LAPTOPSM' | translate" alt="" srcset="" height="35px"
                                width="35px" class="me-2" />
                            </span>
                            <span *ngIf="item?.productKeyType == 'MOBILE'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.MBLSM' | translate" class="me-2" alt="" srcset=""
                                height="18px" />
                            </span>
                            {{
                            item?.deviceName == null
                            ? "N/A"
                            : item?.deviceName
                            }}
                          </div>
                        </div>
                      </span>
                    </tab-title-inline>
                    <div class="q-tab-title ms-0" data-toggle="tooltip"
                      title="{{ 'MANAGEDEVICE.THISISDEFAULT' | translate }}" *ngIf="item.default === true">
                      <small class="fw-bold default-clr">
                        <span class="me-4"> </span>{{ "MANAGEDEVICE.THISISDEFAULT" | translate }}
                      </small>
                    </div>
                  </span>
                </button>
              </div>
              <div id="collapse_{{ i + 50 }}" class="accordion-collapse collapse"
                attr.aria-labelledby="headingOne{{ i + 50 }}" data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <div class="mblsecurityStatImg">
                    <div *ngIf="getUserIndexData.securityStatus === 'insecure'">
                      <p class="mt-3 fw-bold">
                        {{
                        "MANAGEDEVICE.YOURDEVICEISNOTSECURED" | translate
                        }}
                      </p>
                      <p class="text-xl-sm text-lg-xs">
                        {{ getUserIndexData?.lastSyncDate }}
                      </p>
                    </div>
                    <div *ngIf="getUserIndexData.securityStatus === 'secure'">
                      <p class="mt-3 fw-bold">
                        {{ "MANAGEDEVICE.YOURDEVICEISSECURED" | translate }}
                      </p>
                      <p class="text-xl-sm text-lg-xs">
                        {{ getUserIndexData?.lastSyncDate }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="getUserIndexData?.deviceType == 'MOBILE'">
                    <hr />
                    <div class="d-flex justify-content-between align-items-center flex-wrap my-4">
                      <div>
                        <h5 class="fw-bold mb-0">
                          {{ "DASHBOARD.DEVICEFEATURES" | translate }}
                        </h5>
                      </div>
                      <div class="org-clr">
                        <span class="mb-0 fs-18 cursor-pointer" (click)="
                              gotoCommands(
                                getUserIndexData.id,
                                'UPDATE_VIRUS_DB'
                              )
                            ">
                          {{ "MANAGEDEVICE.UPDATEVIRUS" | translate
                          }}<span class="gray-clr ms-1">|</span>
                        </span>
                        <span class="mb-0 fs-18 cursor-pointer" (click)="
                              gotoCommands(getUserIndexData.id, 'SYNC_DEVICE')
                            ">
                          {{ "MANAGEDEVICE.SYNCDEVICE" | translate }}
                        </span>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3">
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCATE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getUserIndexData.id, 'TRACE')">
                        <img [src]="'MANAGEDEVICE.LOCATEIMG' | translate" alt="locate.png" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCATE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.LOCK' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getUserIndexData.id, 'BLOCK')">
                        <img src="../../../assets/images/lock.png" alt="lock" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.LOCK" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.WIPE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="gotoCommands(getUserIndexData.id, 'WIPE')">
                        <img src="../../../assets/images/wipe.png" alt="wipe" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.WIPE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.ANTITHEFT' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            gotoCommands(
                              getUserIndexData.id,
                              'ANTITHEFT_SETTINGS'
                            )
                          ">
                        <img src="../../../assets/images/anti-theft.png" alt="theft" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.ANTITHEFT" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.SCANDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            gotoCommands(getUserIndexData.id, 'SCAN_FROM_CLOUD')
                          ">
                        <img src="../../../assets/images/scan.png" alt="scan" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.SCANDEVICE" | translate }}
                        </div>
                      </div>
                      <div data-toggle="tooltip" i18n-title title="{{ 'MANAGEDEVICE.RINGDEVICE' | translate }}"
                        class="syncdevice-card cursor-pointer" (click)="
                            gotoCommands(getUserIndexData.id, 'RING_DEVICE')
                          ">
                        <img src="../../../assets/images/mng-ringdevice.svg" alt="ring" />
                        <div class="mt-2">
                          {{ "MANAGEDEVICE.RINGDEVICE" | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- deviceDetails index 1 -->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedUsersIndex === 0">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                                expanded
                                  ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                  : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                              " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.deviceName == null
                                      ? "N/A"
                                      : getUserIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYDEVICEUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateDevice(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'MOBILE'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "MANAGEDEVICE.DEVICEOWNER" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getUserIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getUserIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                              'MANAGEDEVICE.PENIMG' | translate
                                            " alt="" (click)="
                                              openDeviceInput(
                                                getUserIndexData.id,
                                                'MYUSERNAME'
                                              )
                                            " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                  updateUserName(
                                                    getUserIndexData.deviceType,
                                                    getUserIndexData.id
                                                  )
                                                ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getUserIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.emailId == null
                                    ? "N/A"
                                    : getUserIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'SYSTEM'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "MANAGEDEVICE.DEVICEOWNER" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getUserIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getUserIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                              'MANAGEDEVICE.PENIMG' | translate
                                            " alt="" (click)="
                                              openDeviceInput(
                                                getUserIndexData.id,
                                                'MYUSERNAME'
                                              )
                                            " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                  updateUserName(
                                                    getUserIndexData.deviceType,
                                                    getUserIndexData.id
                                                  )
                                                ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getUserIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.emailId == null
                                    ? "N/A"
                                    : getUserIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                      loggedInUser.roleType ==
                                        CommonEnum.SUPER_ADMIN ||
                                      loggedInUser.roleType == CommonEnum.ADMIN
                                    " (click)="
                                      openTransferOwnershipModal(
                                        getUserIndexData
                                      )
                                    ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP"
                                  | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="
                                      removeDevicePopup(getUserIndexData)
                                    " class="q-form-white-submit mb-2 me-3">
                                  {{
                                  "MANAGEDEVICE.REMOVEDEVICE" | translate
                                  }}
                                </button></span>
                              <span btn4 *ngIf="
                                    getUserIndexData?.productKeyType ===
                                    'FAMILY_PACK'
                                  ">
                                <button (click)="deactivate(getUserIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE"
                                  | translate
                                  }}
                                </button></span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- licenceDetails index 1-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedUsersIndex === 0">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                                licenseExpanded
                                  ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                  : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                              " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'MOBILE'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productName == null
                                    ? "N/A"
                                    : getUserIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productKey == null
                                    ? "N/A"
                                    : getUserIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getUserIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getUserIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getUserIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.activationDate == null
                                    ? "N/A"
                                    : getUserIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                      getUserIndexData?.licenseValidityDate !==
                                      'Free version'
                                    ">
                                  <button [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>
                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                          getUserIndexData?.licenseValidityDate ===
                                          'Free version'
                                        ">
                                      <button [disabled]="
                                            getUserIndexData?.productLink ==
                                            null
                                          " [ngClass]="
                                            getUserIndexData?.productLink ==
                                            null
                                              ? 'q-invalid-button me-3'
                                              : 'q-form-white-submit cursor-pointer me-3'
                                          " (click)="
                                            openMyIndexRenewLicense(
                                              getUserIndexData,
                                              'PREMIUM'
                                            )
                                          ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'SYSTEM'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productName == null
                                    ? "N/A"
                                    : getUserIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productKey == null
                                    ? "N/A"
                                    : getUserIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getUserIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getUserIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getUserIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.activationDate == null
                                    ? "N/A"
                                    : getUserIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                      getUserIndexData?.licenseValidityDate !==
                                      'Free version'
                                    ">
                                  <button *ngIf="
                                        getMyIndexData?.expirydays < 90 ||
                                        getMyIndexData?.productName ==
                                          'Quick Heal Total Security'
                                      " [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="checkBeforeUserRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                  <button *ngIf="
                                        getMyIndexData?.expirydays >= 90 &&
                                        getMyIndexData?.productName !=
                                          'Quick Heal Total Security'
                                      " [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="
                                        openMyIndexRenewLicense(
                                          getUserIndexData
                                        )
                                      ">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- deviceDetails index 2 -->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedUsersIndex && getUserIndexData">
                      <div id="accordionDevice"
                        class="accordion border-radius device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                                expanded
                                  ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                  : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                              " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}" (click)="toggleContent()">
                            {{'MANAGEDEVICE.DEVICEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!expanded">
                            <div class="col-sm-8">
                              <div class="d-flex flex-wrap mt-3">
                                <div class="col-4">
                                  {{ "MANAGEDEVICE.DEVICENAME" | translate }}
                                </div>
                                <div class="q-tab-content-desc">
                                  <div *ngIf="!enableMyDeviceNameInput" class="d-flex">
                                    <div class="text-truncate">
                                      {{
                                      getUserIndexData?.deviceName == null
                                      ? "N/A"
                                      : getUserIndexData?.deviceName
                                      }}
                                    </div>
                                    <span><img class="cursor-pointer" [src]="
                                            'MANAGEDEVICE.PENIMG' | translate
                                          " alt="" (click)="
                                            openDeviceInput(
                                              getUserIndexData.id,
                                              'MYDEVICEUSERNAME'
                                            )
                                          " /></span>
                                  </div>
                                  <div *ngIf="enableMyDeviceNameInput">
                                    <div class="form-group">
                                      <div class="d-flex">
                                        <div>
                                          <input type="text" class="form-control q-form-control me-3"
                                            [(ngModel)]="deviceUpdatedName" style="width: 250px" />
                                        </div>
                                        <div>
                                          <button type="button" class="q-form-white-submit" (click)="
                                                updateDevice(
                                                  getUserIndexData.deviceType,
                                                  getUserIndexData.id
                                                )
                                              ">
                                            {{ "MANAGEDEVICE.UPDATE" | translate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'MOBILE'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "MANAGEDEVICE.DEVICEOWNER" | translate
                                    }}ss
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getUserIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getUserIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                              'MANAGEDEVICE.PENIMG' | translate
                                            " alt="" (click)="
                                              openDeviceInput(
                                                getUserIndexData.id,
                                                'MYUSERNAME'
                                              )
                                            " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                  updateUserName(
                                                    getUserIndexData.deviceType,
                                                    getUserIndexData.id
                                                  )
                                                ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getUserIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.emailId == null
                                    ? "N/A"
                                    : getUserIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>

                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'SYSTEM'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "MANAGEDEVICE.DEVICEOWNER" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    <div *ngIf="!enableMyCurrentUserNameInput" class="text-capitalize d-flex">
                                      <div class="text-truncate">
                                        {{
                                        getUserIndexData?.currentUserName ==
                                        null
                                        ? "N/A"
                                        : getUserIndexData?.currentUserName
                                        }}
                                      </div>
                                      <span><img class="cursor-pointer" [src]="
                                              'MANAGEDEVICE.PENIMG' | translate
                                            " alt="" (click)="
                                              openDeviceInput(
                                                getUserIndexData.id,
                                                'MYUSERNAME'
                                              )
                                            " /></span>
                                    </div>
                                    <div *ngIf="enableMyCurrentUserNameInput">
                                      <div class="form-group">
                                        <div class="d-flex">
                                          <div>
                                            <input type="text" class="form-control q-form-control me-3"
                                              [(ngModel)]="updateName" style="width: 250px" />
                                          </div>
                                          <div>
                                            <button type="button" class="q-form-white-submit" (click)="
                                                  updateUserName(
                                                    getUserIndexData.deviceType,
                                                    getUserIndexData.id
                                                  )
                                                ">
                                              {{ "MANAGEDEVICE.UPDATE" | translate }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.PHONENO" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.mobileNo == null
                                    ? "N/A"
                                    : getUserIndexData?.mobileNo
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{ "MANAGEDEVICE.EMAILID" | translate }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.emailId == null
                                    ? "N/A"
                                    : getUserIndexData?.emailId
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 mb-3 mt-3">
                              <span btn2><button class="q-form-white-submit mb-2 me-3" *ngIf="
                                      loggedInUser.roleType ==
                                        CommonEnum.SUPER_ADMIN ||
                                      loggedInUser.roleType == CommonEnum.ADMIN
                                    " (click)="
                                      openTransferOwnershipModal(
                                        getUserIndexData
                                      )
                                    ">
                                  {{
                                  "MANAGEDEVICE.TRANSFEROWNERSHIP"
                                  | translate
                                  }}
                                </button>
                              </span>

                              <span btn3>
                                <button (click)="
                                      removeDevicePopup(getUserIndexData)
                                    " class="q-form-white-submit mb-2 me-3">
                                  {{
                                  "MANAGEDEVICE.REMOVEDEVICE" | translate
                                  }}
                                </button></span>
                              <span btn4 *ngIf="
                                    getUserIndexData?.productKeyType ===
                                    'FAMILY_PACK'
                                  ">
                                <button (click)="deactivate(getUserIndexData)" class="q-form-white-submit mb-2">
                                  {{
                                  "MANAGEDEVICE.DEACTIVSTEDEVICE"
                                  | translate
                                  }}
                                </button></span>

                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <!-- licenceDetails index 2-->
                  <div class="p-0 mb-4 qh-vertical-content border-radius">
                    <ng-container *ngIf="selectedUsersIndex && getUserIndexData">
                      <div id="accordionDevice"
                        class="accordion device-accordion q-vertical-contents left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch p-0 d-flex flex-wrap align-items-center justify-content-between"
                        [ngClass]="
                            selectedUsersIndex
                              ? 'border-radius'
                              : 'border-radius'
                          ">
                        <div class="accordion-item-device bg-white">
                          <button [ngClass]="
                                licenseExpanded
                                  ? 'accordion-button shadow-none  relative p-4 bg-white border-0'
                                  : 'accordion-button shadow-none collapsed relative p-4 bg-white border-0'
                              " type="button" data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ 0 }}"
                            aria-expanded="false" attr.aria-controls="collapseOne{{ 0 }}"
                            (click)="toggleLicenseContent()">
                            {{'MANAGEDEVICE.LICENSEDETAILSSTR' | translate}}
                          </button>
                          <div class="row p-4 qh-vertical-content" [hidden]="!licenseExpanded">
                            <div class="col-sm-8">
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'MOBILE'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productName == null
                                    ? "N/A"
                                    : getUserIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productKey == null
                                    ? "N/A"
                                    : getUserIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getUserIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getUserIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getUserIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getUserIndexData?.id,getUserIndexData?.deviceType,'userIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.activationDate == null
                                    ? "N/A"
                                    : getUserIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="mt-4" style="width: 120px" *ngIf="
                                      getUserIndexData?.licenseValidityDate !==
                                      'Free version'
                                    ">
                                  <button [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="checkBeforeRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                </div>

                                <div class="d-flex mt-4 mb-3">
                                  <div class="q-tab-content-title">
                                    <div *ngIf="
                                          getUserIndexData?.licenseValidityDate ===
                                          'Free version'
                                        ">
                                      <button [disabled]="
                                            getUserIndexData?.productLink ==
                                            null
                                          " [ngClass]="
                                            getUserIndexData?.productLink ==
                                            null
                                              ? 'q-invalid-button me-3'
                                              : 'q-form-white-submit cursor-pointer me-3'
                                          " (click)="
                                            openMyIndexRenewLicense(
                                              getUserIndexData,
                                              'PREMIUM'
                                            )
                                          ">
                                        {{
                                        "LICENSESUMMARY.BUYPREMIUM"
                                        | translate
                                        }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="
                                    getUserIndexData?.deviceType == 'SYSTEM'
                                  ">
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTNAME" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productName == null
                                    ? "N/A"
                                    : getUserIndexData?.productName
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.PRODUCTKEY" | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.productKey == null
                                    ? "N/A"
                                    : getUserIndexData?.productKey
                                    }}
                                  </div>
                                </div>

                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.BUILDVERSION"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.buildVersion == null
                                    ? "N/A"
                                    : getUserIndexData?.buildVersion
                                    }}
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.LICENSEVALIDITY"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc d-flex align-items-center">
                                    {{
                                    getUserIndexData?.licenseValidityDate ==
                                    null
                                    ? "N/A"
                                    : getUserIndexData?.licenseValidityDate
                                    }}

                                    <span class="ms-1 cursor-pointer"
                                      onclick="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                                    </span>
                                    <span
                                      (click)="updateProductKeyLicenceDetails(getMyIndexData?.productKey,getMyIndexData?.deviceType,'myIndexData')">
                                      <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                        {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                                    </span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3">
                                  <div class="col-4">
                                    {{
                                    "LICENSESUMMARY.ACTIVATIONDATE"
                                    | translate
                                    }}
                                  </div>
                                  <div class="q-tab-content-desc">
                                    {{
                                    getUserIndexData?.activationDate == null
                                    ? "N/A"
                                    : getUserIndexData?.activationDate
                                    }}
                                  </div>
                                </div>

                                <div *ngIf="getMyIndexData">
                                  <div class="d-flex flex-wrap mt-3">
                                    <div class="col-4">
                                      {{
                                      "LICENSESUMMARY.AUTORENEW" | translate
                                      }}
                                    </div>
                                    <div class="q-tab-content-desc">
                                      {{
                                      getMyIndexData.autoRenewal == 1
                                      ? ("MANAGEDEVICE.YES" | translate)
                                      : ("MANAGEDEVICE.NO" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4" style="width: 120px" *ngIf="
                                      getUserIndexData?.licenseValidityDate !==
                                      'Free version'
                                    ">
                                  <button *ngIf="
                                        getMyIndexData?.expirydays < 90 ||
                                        getMyIndexData?.productName ==
                                          'Quick Heal Total Security'
                                      " [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="checkBeforeUserRenew()">
                                    {{ "LICENSESUMMARY.RENEW" | translate }}
                                  </button>
                                  <button *ngIf="
                                        getMyIndexData?.expirydays >= 90 &&
                                        getMyIndexData?.productName !=
                                          'Quick Heal Total Security'
                                      " [disabled]="
                                        !getUserIndexData?.productLink
                                      " [ngClass]="
                                        getUserIndexData?.productLink == null
                                          ? 'q-invalid-button px-4 w-100'
                                          : 'submit-btn bg-orgclr w-100'
                                      " (click)="
                                        openMyIndexRenewLicense(
                                          getUserIndexData
                                        )
                                      ">
                                    {{ "LICENSESUMMARY.UPGRADE" | translate }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Transfer ownership popup -->
<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="transferOwnershipPopup"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <ng-container *ngIf="!isTransferOwnership">
    <div class="modal-dialog relative w-auto pointer-events-none q-addDeviceModal adduserPopup modal-dialog-centered">
      <div
        class="modal-content border-none rounded-25 shadow-lg relative d-flex flex-column w-100 pointer-events-auto outline-none">
        <div class="modal-body relative p-md-5 p-4">
          <div class="mb-3 text-center">
            <app-main-heading>
              <span title>{{
                "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.TRANSFEROWNERSHIP"
                | translate
                }}</span>
            </app-main-heading>
          </div>
          <div *ngIf="getTransferOwnershipUser?.length == 0">
            <p class="mt-3 text-center">
              {{ "MANAGEDEVICE.NOUSERFOUND" | translate }}
            </p>
            <div class="d-flex justify-content-center align-items-center" *ngIf="modalForEng">
              <div class="me-3">
                <button type="button" class="bg-orgclr w-auto submit-btn shadow-none" (click)="openAddUser()">
                  {{ "MANAGEUSER.ADDUSER" | translate }}
                </button>
              </div>
              <div>
                <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeSuccessModal()">
                  {{ "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CANCEL" | translate }}
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-center w-100 flex-wrap align-items-center" *ngIf="!modalForEng">
              <div class="w-100 mb-3">
                <button type="button" class="bg-orgclr w-100 submit-btn shadow-none" (click)="openAddUser()">
                  {{ "MANAGEUSER.ADDUSER" | translate }}
                </button>
              </div>
              <div class="w-100">
                <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeSuccessModal()">
                  {{ "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="getTransferOwnershipUser?.length != 0 && modalForEng">
            <form [formGroup]="transferOwnershipForm" (ngSubmit)="onTransferOwnership()">
              <div class="form-div">
                <div class="form-group mb-2">
                  <div class="">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICENAME"
                        | translate
                        }}
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.deviceName == null
                        ? "N/A"
                        : getPopupDataById?.deviceName
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="">
                    <div class="">
                      <label for="prodKey" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.PRODUCTKEY"
                        | translate
                        }}
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.productKey == null
                        ? "N/A"
                        : getPopupDataById?.productKey
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICETYPE"
                        | translate
                        }}
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.deviceType == null
                        ? "N/A"
                        : getPopupDataById?.deviceType
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CURRENTUSER"
                        | translate
                        }}
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.currentUserName == null
                        ? "N/A"
                        : getPopupDataById?.currentUserName
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label for="name" class="q-tab-content-title">{{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.NEWUSER" | translate
                    }}
                    <span class="text-danger"> *</span></label>

                  <select name="" id="" class="form-select transferSelect cursor-pointer shadow-none w-100"
                    (ngModelChange)="transferOwnershipUsername($event)" formControlName="assignedUserId">
                    <option value="undefined" disabled>Select User</option>
                    <option [value]="loggedInUser.id" *ngIf="openUserDeviceContent === true">
                      Self ({{ loggedInUser.roleTypeStr }})
                    </option>
                    <option *ngFor="let item of getTransferOwnershipUser"
                      [hidden]="getPopupDataById?.currentUserId == item.id" [value]="item.id">
                      {{ item.name }} ({{ item.roleTypeStr }})
                    </option>
                  </select>
                </div>
                <div class="form-group mt-4">
                  <button type="submit" [disabled]="transferOwnershipForm.invalid" [ngClass]="
                      transferOwnershipForm.invalid
                        ? 'q-invalid-button  w-100'
                        : 'submit-btn bg-orgclr w-100'
                    ">
                    {{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.TRANSFER" | translate
                    }}
                  </button>
                </div>
                <div class="form-group mt-3">
                  <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeSuccessModal()">
                    {{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CANCEL" | translate
                    }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="getTransferOwnershipUser?.length != 0 && !modalForEng">
            <form [formGroup]="transferOwnershipForm" (ngSubmit)="onTransferOwnership()">
              <div class="form-div">
                <div class="form-group mb-2">
                  <div class="d-flex align-items-center">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICENAME"
                        | translate
                        }}
                        :</label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.deviceName == null
                        ? "N/A"
                        : getPopupDataById?.deviceName
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="d-flex align-items-center">
                    <div class="">
                      <label for="prodKey" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.PRODUCTKEY"
                        | translate
                        }}
                        :
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.productKey == null
                        ? "N/A"
                        : getPopupDataById?.productKey
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="d-flex align-items-center">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICETYPE"
                        | translate
                        }}
                        :
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.deviceType == null
                        ? "N/A"
                        : getPopupDataById?.deviceType
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <div class="d-flex align-items-center">
                    <div class="">
                      <label for="name" class="q-tab-content-title">{{
                        "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CURRENTUSER"
                        | translate
                        }}
                        :
                      </label>
                    </div>
                    <div>
                      <div class="q-tab-content-desc">
                        {{
                        getPopupDataById?.currentUserName == null
                        ? "N/A"
                        : getPopupDataById?.currentUserName
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label for="name" class="q-tab-content-title">{{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.NEWUSER" | translate
                    }}
                    <span class="text-danger"> *</span></label>

                  <select name="" id="" class="form-select transferSelect cursor-pointer shadow-none w-100"
                    (ngModelChange)="transferOwnershipUsername($event)" formControlName="assignedUserId">
                    <option value="undefined" disabled>Select User</option>
                    <option [value]="loggedInUser.id" *ngIf="openUserDeviceContent === true">
                      Self ({{ loggedInUser.roleTypeStr }})
                    </option>
                    <option *ngFor="let item of getTransferOwnershipUser"
                      [hidden]="getPopupDataById?.currentUserId == item.id" [value]="item.id">
                      {{ item.name }} ({{ item.roleTypeStr }})
                    </option>
                  </select>
                </div>
                <div class="form-group mt-4">
                  <button type="submit" [disabled]="transferOwnershipForm.invalid" [ngClass]="
                      transferOwnershipForm.invalid
                        ? 'q-invalid-button  w-100'
                        : 'submit-btn bg-orgclr w-100'
                    ">
                    {{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.TRANSFER" | translate
                    }}
                  </button>
                </div>
                <div class="form-group mt-3">
                  <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeSuccessModal()">
                    {{
                    "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.CANCEL" | translate
                    }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isTransferOwnership">
    <div class="modal-dialog relative modal-dialog-centered">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative px-5">
          <div class="text-center">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-4">
              {{
              "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.OWNERSHIPTRANSFERSUCCESS"
              | translate
              }}
            </h5>
            <p class="text-sm">
              {{
              "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DEVICEOWNERSHIPTO"
              | translate
              }}

              <span *ngIf="getUser">{{ getUser }}</span>
            </p>
            <button class="submit-btn bg-orgclr" (click)="closeSuccessModal()">
              {{ "MANAGEDEVICE.TRASFEROWNERSHIPPOPUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<!-- {{ "MANAGEDEVICE.VERIFYDETAILS" | translate }} popup -->
<div class="modal" id="verifyDetailsPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="isMobile">
      <div class="modal-content p-3 forgotpwd rounded-25">
        <!-- Modal Header -->
        <div class="text-center mx-4">
          <h5 class="my-2">
            <app-main-heading>
              <span title> {{ "MANAGEDEVICE.VERIFYDETAILS" | translate }}</span>
            </app-main-heading>
          </h5>
          <p class="text-xs">
            {{ "MANAGEDEVICE.PLEASEADDMOBILE" | translate }}
          </p>
        </div>
        <!-- Modal body -->
        <form [formGroup]="deviceDetailForm" (ngSubmit)="verifyDeviceDetail()">
          <div class="form-div">
            <div class="form-group mb-3">
              <label for="mblNumoremail" class="mb-1 q-form-label">{{ "MANAGEDEVICE.MOBILENO" | translate }}
                <span class="text-danger">*</span></label>
              <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
                  CountryISO.UnitedStates,
                  CountryISO.UnitedKingdom
                ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
                customPlaceholder="{{ 'SIGNUP.ENTERYOURMBLNO' | translate }}" [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                [phoneValidation]="true" name="phone" formControlName="userName" (keydown)="removeSpace($event, '')"
                (keypress)="keyPressAlphaNumericWithCharacters($event, '')" (keyup)="onFocusOutMobile($event)">
              </ngx-intl-tel-input>
              <ng-container *ngIf="mobileNoWrong">
                <p class="errMessage">
                  {{ "MANAGEDEVICE.MINANDMAX8" | translate }}
                </p>
              </ng-container>
            </div>

            <div class="mt-3 mb-4">
              <button type="submit" [disabled]="
                  deviceDetailForm.controls['userName'].value?.number?.length <
                  8
                " [ngClass]="
                  deviceDetailForm.controls['userName'].value?.number?.length <
                  8
                    ? 'q-invalid-button mb-3 w-100'
                    : 'submit-btn bg-orgclr mb-3 w-100'
                ">
                {{ "LOGIN.SUBMIT" | translate }}
              </button>
              <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="isOTP">
      <div class="modal-content p-3 enterotp">
        <div class="text-center mt-3">
          <h5 class="mb-0">
            <app-main-heading>
              <span title> {{ "LOGIN.ENTEROTP" | translate }}</span>
            </app-main-heading>
          </h5>
          <small>{{ "LOGIN.SENTON" | translate }} {{ mobileNumber }}</small>
        </div>
        <!-- Modal body -->
        <div class="">
          <div class="mt-4 form-group">
            <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
              <span>
                <div class="charClass me-2 me-md-3">
                  {{ emailResponse }}
                </div>
              </span>
              <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"
                #ngOtpInput>
              </ng-otp-input>
            </div>
          </div>
          <ng-container *ngIf="otpError">
            <p class="errMessage" style="margin: 10px 90px">{{ otpError }}</p>
          </ng-container>
          <div class="mt-4 mb-3 form-div">
            <button type="button" class="submit-btn bg-orgclr w-100 mb-3" (click)="submitOTP()">
              {{ "LOGIN.SUBMIT" | translate }}
            </button>
            <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>

          <ng-container *ngIf="isOTP && timeOver">
            <div class="d-flex align-items-center justify-content-center mb-3">
              <small>
                {{ "RESENDOT.RESENDOTPIN" | translate }}
                {{ durationMinutes }}</small>
            </div>
          </ng-container>
          <div class="d-flex mt-2 align-items-center justify-content-center notOtpDiv mb-3" *ngIf="!timeOver && isOTP">
            <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
            <button type="button" class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
              (click)="resendOtp()">
              {{ "LOGIN.RESEND" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isDone">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="fw-bold mt-3 mb-3">
              {{ "SUCESSMESSAGE.PHONEVERIFIED" | translate }}
            </h5>
            <button class="submit-btn bg-orgclr w-auto" (click)="closeVerifyDetails()">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- remove device popup -->
<div class="modal" id="removeDevicePopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="!isDeviceRemoved">
      <div class="modal-content px-4 rounded-25">
        <!-- Modal Header -->
        <div class="text-center">
          <div class="mt-3">
            <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
          </div>
          <h5 class="fw-bold mt-3 mb-2">
            {{ "MANAGEDEVICE.REMOVEDEVICEPOPUP.DOYOUWANT" | translate }}
          </h5>
          <p class="mb-0 text-sm">
            {{ "MANAGEDEVICE.DEVICENAME" | translate }}
            {{ remoDeviceName == null ? "N/A" : remoDeviceName }}
          </p>
        </div>

        <!-- Modal body -->

        <div class="my-4 d-flex justify-content-center">
          <button (click)="removeAddedDevice()" class="submit-btn bg-orgclr me-3">
            {{ "MANAGEDEVICE.REMOVEDEVICEPOPUP.REMOVE" | translate }}
          </button>
          <button class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal">
            {{ "MANAGEDEVICE.REMOVEDEVICEPOPUP.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isDeviceRemoved">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-5">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-4 mb-0">
              {{ "SUCESSMESSAGE.DEVICEREMOVEDSUCCESSFULLY" | translate }}.
            </h5>
            <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- remove device popup -->
<div class="modal" id="deActivateDevicePopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container>
      <div class="modal-content px-4 rounded-25">
        <!-- Modal Header -->
        <div class="text-center">
          <div class="mt-3">
            <img src="./assets/images/delete.svg" alt="" class="mx-auto" />
          </div>
          <h5 class="fw-bold mt-3 mb-2">
            {{ "SUCESSMESSAGE.WANTTOREMOVEDEVICE" | translate }}
          </h5>
          <p class="mb-0 text-sm">
            {{ "MANAGEDEVICE.DEVICENAME" | translate }}
            {{ deactiveDeviceName == null ? "N/A" : deactiveDeviceName }}
          </p>
          <p class="mb-3">
            {{ "MANAGEDEVICE.DEACTIVATELIACENSENOTE" | translate }}
          </p>
        </div>
        <ng-container *ngIf="errorMessageDeactivate">
          <p class="errMessage" style="margin: 10px 90px">
            {{ errorMessageDeactivate }}
          </p>
        </ng-container>
        <!-- Modal body -->

        <div class="justify-content-center my-4 d-flex">
          <button (click)="deActivateAddedDevice()" class="submit-btn bg-orgclr me-3">
            {{ "MANAGEDEVICE.REMOVEDEVICEPOPUP.DEACTIVATE" | translate }}
          </button>
          <button class="cancel-btn bg-cancelbtn" (click)="closeDeactivate()">
            {{ "MANAGEDEVICE.REMOVEDEVICEPOPUP.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isLicenseRemoved">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-5">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-4 mb-0">
              {{ "SUCESSMESSAGE.DEVICEREMOVEDSUCCESSFULLY" | translate }}.
            </h5>
            <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Add User Popup -->

<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="addUserPopup"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <ng-container *ngIf="!isDone">
    <div class="modal-dialog relative w-auto pointer-events-none q-addDeviceModal adduserPopup modal-dialog-centered">
      <div
        class="modal-content border-none rounded-25 shadow-lg relative d-flex flex-column w-100 pointer-events-auto outline-none">
        <div class="modal-body relative">
          <div class="mx-4 my-3">
            <h4 class="text-center">
              <app-main-heading>
                <span title> {{ "MANAGEUSER.ADDUSER" | translate }}</span>
              </app-main-heading>
            </h4>
          </div>
          <form [formGroup]="addUserForm" (ngSubmit)="openAddUser()">
            <div class="form-div">
              <div class="form-group mb-2">
                <label for="name" class="q-form-label">{{ "MANAGEUSER.NAME" | translate
                  }}<span class="text-danger">*</span></label>
                <input type="text" #testInput autocomplete="off" minlength="3" maxlength="50" (keypress)="
                    keyPressAlphaNumericWithCharacters($event, 'name')
                  " (keydown)="removeSpace($event, 'name')" (keydown)="onlyAlphabets($event)"
                  class="form-control q-form-control" formControlName="name" placeholder="Please Enter Name" />
              </div>
              <div class="form-group mb-2" *ngIf="loggedInUser.roleType == CommonEnum.ADMIN">
                <label class="q-form-label">{{ "MANAGEUSER.ROLES" | translate
                  }}<span class="text-danger">*</span></label>
                <input type="text" readonly [value]="CommonEnum.MEMBERS" formControlName="role"
                  class="form-control q-form-control" placeholder="MEMBER" />
              </div>
              <div class="form-group mb-2" *ngIf="loggedInUser.roleType == CommonEnum.SUPER_ADMIN">
                <label class="q-form-label">{{ "MANAGEUSER.ROLES" | translate
                  }}<span class="text-danger">*</span></label>
                <select formControlName="role"
                  class="w-100 bg-white border h-45 py-2 px-2 form-select transferSelect cursor-pointer">
                  <option selected disabled value="">
                    {{ "MANAGEUSER.SELECTROLE" | translate }}
                  </option>
                  <option [hidden]="loggedInUser.roleType == CommonEnum.ADMIN" [value]="CommonEnum.ADMIN">
                    {{ "MANAGEUSER.ADMIN" | translate }}
                  </option>
                  <option *ngIf="
                      loggedInUser.roleType == CommonEnum.SUPER_ADMIN ||
                      loggedInUser.roleType == CommonEnum.ADMIN
                    " [value]="CommonEnum.MEMBERS">
                    {{ "MANAGEUSER.MEMBER" | translate }}
                  </option>
                  <option [hidden]="
                      loggedInUser.roleType !== CommonEnum.SUPER_ADMIN ||
                      loggedInUser.roleType !== CommonEnum.ADMIN ||
                      loggedInUser.roleType !== CommonEnum.MEMBERS
                    " [value]="CommonEnum.SUPER_ADMIN">
                    {{ "MANAGEUSER.SUPERADMIN" | translate }}
                  </option>
                </select>
              </div>
              <div class="form-group mb-2">
                <label for="email" class="q-form-label">{{ "ADDDEVICE.EMAIL" | translate }}
                  <span class="text-danger">*</span></label>
                <input type="email" autocomplete="off" class="form-control q-form-control"
                  placeholder="Please Enter Email" minlength="8" maxlength="100" formControlName="email"
                  (keydown)="removeSpace($event, 'email')" (keypress)="
                    keyPressAlphaNumericWithCharacters($event, 'email')
                  " />
              </div>

              <ng-container *ngIf="addUserErrorMessage">
                <p class="errMessage">{{ addUserErrorMessage }}</p>
              </ng-container>

              <div class="my-3">
                <button type="submit" [disabled]="addUserForm.invalid" [ngClass]="
                    addUserForm.invalid
                      ? 'q-invalid-button mb-3 w-100'
                      : 'submit-btn bg-orgclr mb-3 w-100 '
                  ">
                  {{ "MANAGEUSER.ADD" | translate }}
                </button>
                <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeAddUserModal()">
                  {{ "LOGIN.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isDone">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
      <div
        class="modal-content border-none shadow-lg relative text-center rounded-25 w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-4">
          <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
        </div>
        <h5 class="q-modal-heading mt-4">
          {{ "SUCESSMESSAGE.INVITSUCCESS" | translate }}
        </h5>
        <span class="text-xs">{{ "SUCESSMESSAGE.EMAILINVITE" | translate }}
          {{ emailSentUserName }}</span>
        <div class="text-center">
          <div class="q-tab-content-title">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Act now popup -->
<div class="modal" id="actNowPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="actNowPopup">
    <ng-container>
      <div class="modal-content px-4 rounded-25" style="width: 611px">
        <div class="text-center text-act-now mt-4 mb-1">
          {{ "MANAGEDEVICE.YOURDEVICEISNOTSECURED" | translate }}
        </div>

        <div style="position: absolute; top: 25px; right: 25px">
          <span (click)="closeModal5()"><img src="./assets/images/otpCancel.svg" alt=""
              class="ms-xl-4 cursor-pointer" /></span>
        </div>

        <div class="act-now-card mt-1 mb-3" *ngIf="
            (getMyIndexData &&
              openMyDeviceContent &&
              getMyIndexData?.detected === true) ||
            (getUserIndexData &&
              openUserDeviceContent &&
              getUserIndexData?.detected === true)
          ">
          <div class="mt-3 px-3">
            <strong>{{
              "MANAGEDEVICE.ACTIVETHREATDETECTED" | translate
              }}</strong>
          </div>

          <div class="act-text-line mt-3 px-3">
            {{ "MANAGEDEVICE.DEVICETEXT" | translate }}
          </div>

          <ul class="list-unstyled mt-2">
            <li class="act-text-line px-5">
              {{ "MANAGEDEVICE.DEVICETEXT1" | translate }}
            </li>
            <li class="act-text-line px-5">
              {{ "MANAGEDEVICE.DEVICETEXT2" | translate }}
            </li>
            <li class="act-text-line px-5">
              {{ "MANAGEDEVICE.DEVICETEXT3" | translate }}
            </li>
          </ul>
        </div>

        <div class="act-now-card mt-1 mb-5" *ngIf="
            (getMyIndexData &&
              openMyDeviceContent &&
              getMyIndexData?.securityStatus === 'insecure') ||
            (getUserIndexData &&
              openUserDeviceContent &&
              getUserIndexData?.securityStatus === 'insecure')
          ">
          <div class="mt-3 px-3">
            <strong>{{ "MANAGEDEVICE.VIRUSSIGN" | translate }}</strong>
          </div>
          <div class="act-text-line mt-1 mb-1 px-3">
            {{ "MANAGEDEVICE.SYNCVIRUSSIGN" | translate }}
          </div>
        </div>
        <div class="justify-content-center my-3 d-flex px-3" *ngIf="openMyDeviceContent">
          <button (click)="openSyncScoreModal(getMyIndexData.id, 'SYNC_DEVICE')" class="submit-btn bg-orgclr me-3">
            {{ "MANAGEUSER.SYNCSCORE" | translate }}
          </button>
        </div>

        <div class="justify-content-center my-3 d-flex px-3" *ngIf="!openMyDeviceContent">
          <button (click)="openSyncScoreModal(getUserIndexData?.id, 'SYNC_DEVICE')" class="submit-btn bg-orgclr me-3">
            {{ "MANAGEUSER.SYNCSCORE" | translate }}
          </button>
        </div>

        <!-- Modal body -->
      </div>
    </ng-container>

    <ng-container *ngIf="isLicenseRemoved">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-5">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold mt-4 mb-0">
              {{ "SUCESSMESSAGE.DEVICEREMOVEDSUCCESSFULLY" | translate }}.
            </h5>
            <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Renew button popup -->
<div class="modal" id="renewPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-3">
          <img src="./assets/images/not secure.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-1 mb-2">
          {{ "LICENSESUMMARY.RENEWPOPUP" | translate }}
        </h5>
        <p class="text-sm p-xl-2">
          {{ "LICENSESUMMARY.RENEWDESC" | translate }}
        </p>

        <div class="text-center mb-4 mt-1 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Before Transfer ownership -->

<div class="modal" id="transferOwnerShipBefore" data-bs-backdrop="static">
  <div class="modal-dialog transferowneshipwidth modal-dialog-centered">
    <div class="modal-dialog transferowneshipwidth relative w-100 pointer-events-none">
      <div
        class="modal-content border-none shadow-lg p-4 rounded-25 relative w-100 pointer-events-auto bg-white outline-none">
        <div class="text-center align-items-center">
          <div class="modal-header-ownership">
            {{ "MANAGEUSER.TRANSFEROWNERSHIP" | translate }}
          </div>
          <div class="">
            <img src="./assets/images/transferOwner.svg" alt="" class="mx-auto" />
          </div>
          <div class="modal-ownership-desc mt-3">
            {{ "MANAGEUSER.TRANSFEROWNERSHIPDESC" | translate }}
          </div>
          <div class="d-flex justify-content-center align-items-center mt-4" *ngIf="modalForEng">
            <div class="me-3">
              <button type="button" class="q-form-white-submit mb-0 me-2 cancel-btn" data-bs-dismiss="modal">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
            <div class="">
              <button class="submit-btn bg-orgclr" (click)="openTransferOwnershipPage()">
                {{ "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate }}
              </button>
            </div>
          </div>
          <div class="w-100 flex-nowrap align-items-center mw-400 mx-auto mt-4" style="float: right"
            *ngIf="!modalForEng">
            <button type="button" class="q-form-white-submit mb-0 me-3 cancel-btn" data-bs-dismiss="modal">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
            <button class="submit-btn bg-orgclr" style="padding-left: 22px; padding-right: 22px"
              (click)="openTransferOwnershipPage()">
              {{ "MANAGEDEVICE.TRANSFEROWNERSHIP" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Device Scan in progress popup-->
<div class="modal" id="scanPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <h5 class="fw-bold mt-3 mb-2">
          {{ "MANAGEDEVICE.SCANWITHDEVICE" | translate }}
        </h5>
        <div class="mt-2">
          <img src="./assets/images/SCANDEVICE.png" alt="" style="height: 150px" />
        </div>
        <p class="text-sm mx-xxl-5 mt-2">
          {{ "MANAGEDEVICE.SCANINPROGRESSMSG" | translate }}
        </p>
        <div class="text-center mb-4 mt-1 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Device Commands popup -->
<div class="modal" id="deviceCommandPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered justify-content-center">
    <ng-container>
      <div
        class="modal-content text-center border-none rounded-25 shadow-lg relative w-500 pointer-events-auto bg-white outline-none"
        style="width: 950px">
        <div class="text-left px-4 mt-4" style="width: 750px">
          <h5 class="fw-bold mt-1 mb-4 px-3">
            {{ "MANAGEDEVICE.DEVICECOMMANDS" | translate }}
          </h5>
          <div style="position: absolute; top: 25px; right: 25px">
            <span (click)="closeModal4()"><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4" /></span>
          </div>
          <diV class="container-fluid">
            <div class="row ms-1">
              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'SYSTEM' ||
              getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.SCAN" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.SCAN1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="
                  getMyIndexData?.deviceType == 'SYSTEM' ||
                  getMyIndexData?.deviceType == 'MOBILE'
                ">
                <div class="device-label">
                  {{ "MANAGEDEVICE.SYNC" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.SCYN1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.RING" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.RING1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.LOCATE" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.LOCATE1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.LOCK" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.LOCK1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.WIPE" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.WIPE1" | translate }}
                </div>
              </div>

              <div class="row mt-2 device-row" *ngIf="getMyIndexData?.deviceType == 'MOBILE'">
                <div class="device-label">
                  {{ "MANAGEDEVICE.ANTITHEFT" | translate }}
                </div>
                <div class="device-desc">
                  {{ "MANAGEDEVICE.ANTITHEFT1" | translate }}
                </div>
              </div>
            </div>
          </diV>
        </div>

        <div></div>
        <div class="text-center mb-4 mt-2 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Modal -->
<div class="modal" id="controlRequestPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered opt-popup relative w-auto pointer-events-none actOncontrolPopupWidth">
    <div
      class="modal-content border-none shadow-lg actOncontrolPopupWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">

      <!-- Modal Header -->
      <div class="mt-0 actOncontrolPopupWidth">
        <h4>
          <app-main-heading>
            <span class="text-transform-none" title>
              <span *ngFor="let name of requestTypeDisplayNames; let i = index">
                {{ name }}
                <span *ngIf="i !== requestTypeDisplayNames.length - 1">, </span>
              </span>
              <span>
                {{ "MANAGEDEVICE.HASWORKING" | translate }}
              </span>
            </span>
          </app-main-heading>
        </h4>
      </div>

      <!-- Alert Box -->
      <div class="mt-3 device-control-popup" *ngIf="getMyIndexData?.deviceType==='MOBILE'">
        <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
        <span *ngFor="let name of requestTypeDisplayNames; let i = index">
          {{ name }}
          <span *ngIf="i !== requestTypeDisplayNames.length - 1">, </span>
          <span>
            {{"MANAGEDEVICE.STOPPEDWORKINGONDEVICE" | translate}} {{ cmdfailedDeviceName }}.
          </span>
        </span>

      </div>

      <div class="mt-3 device-control-popup" *ngIf="getMyIndexData?.deviceType==='SYSTEM'">
        <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
        <span *ngFor="let name of requestTypeDisplayNames; let i = index">
          {{ name }}
          <span *ngIf="i !== requestTypeDisplayNames.length - 1">, </span>
          <span>
            {{"MANAGEDEVICE.SYSTEMSTOPPEDWORKINGONDEVICE" | translate}} {{ cmdfailedDeviceName }}.
          </span>
        </span>
      </div>

      <!-- Modal Body -->
      <div class="mt-3 device-ctrl-request-width">
        <div class="mt-1 settings-security-feature" *ngIf="getMyIndexData?.deviceType==='MOBILE'">
          <span> {{ "MANAGEDEVICE.SENDREQUESTDESC" | translate }}</span>
        </div>
        <div class="mt-1 settings-security-feature" *ngIf="getMyIndexData?.deviceType==='SYSTEM'">
          <span [innerHTML]="'MANAGEDEVICE.SYSTEMSENDREQUESTDESC' | translate"></span>
        </div>


        <div class="mt-3 mb-1">
          <button class="device-pop-submit-btn " (click)="sendCommands()">
            {{ "DASHBOARD.SENDAREQUEST" | translate }}
          </button>
        </div>
        <div class="mt-2 settings-security-feature">
          <span> <img src="./assets/images/Info.png" alt="Close" style="margin-bottom: 3px" /> {{
            "MANAGEDEVICE.NOTEFORSENREQUEST" |
            translate }} </span>
        </div>
      </div>

      <!-- Close Button -->
      <div class="cross-arrow-pos">
        <span (click)="hideSendControlPopup()">
          <img src="./assets/images/otpCancel.svg" alt="Close" class="ms-xl-4" />
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal" id="multiControlRequestPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered opt-popup relative w-auto pointer-events-none actOncontrolPopupWidth">
    <div
      class="modal-content border-none shadow-lg actOncontrolPopupWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">

      <!-- Modal Header -->
      <div class="mt-0 actOncontrolPopupWidth">
        <h4>
          <app-main-heading>
            <span class="text-transform-none" title>
              <span>
                {{ "MANAGEDEVICE.MULTIPLESETTINGFAILED" | translate }}
              </span>
            </span>
          </app-main-heading>
        </h4>
      </div>

      <div class="mt-3 device-control-popup" *ngIf="getMyIndexData?.deviceType==='MOBILE'">
        <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
        <div>
          <div>
            <span *ngFor="let name of requestTypeDisplayNames; let i = index">
              {{ name }}<span *ngIf="i !== requestTypeDisplayNames.length - 1">, </span>
            </span>
            <span class="">
              {{"MANAGEDEVICE.MOBILECONTROLSTOPPEDWORKING" | translate}} {{ cmdfailedDeviceName }}.
            </span>
          </div>

        </div>
      </div>


      <div class="mt-3 device-control-popup" *ngIf="getMyIndexData?.deviceType==='SYSTEM'">
        <img [src]="'DASHBOARD.ALERTLICENSE' | translate" width="21" height="21" alt="" />
        <div>
          <div>
            <span *ngFor="let name of requestTypeDisplayNames; let i = index">
              {{ name }}<span *ngIf="i !== requestTypeDisplayNames.length - 1">, </span>
            </span>
            <span class="">
              {{"MANAGEDEVICE.SYSTEMHASWORKING" | translate}} {{ cmdfailedDeviceName }}.
            </span>
          </div>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="mt-3 device-ctrl-request-width">
        <div class="mt-1 settings-security-feature" *ngIf="getMyIndexData?.deviceType==='MOBILE'">
          <span> {{ "MANAGEDEVICE.SENDREQUESTDESC" | translate }}</span>
        </div>
        <div class="mt-1 settings-security-feature" *ngIf="getMyIndexData?.deviceType==='SYSTEM'">
          <span [innerHTML]="'MANAGEDEVICE.SYSTEMSENDREQUESTDESC' | translate"></span>
        </div>


        <div class="mt-3 mb-1">
          <button class="device-pop-submit-btn " (click)="sendCommands()">
            {{ "DASHBOARD.SENDAREQUEST" | translate }}
          </button>
        </div>
        <div class="mt-2 settings-security-feature">
          <span> <img src="./assets/images/Info.png" alt="Close" /> {{ "MANAGEDEVICE.NOTEFORSENREQUEST" |
            translate }} </span>
        </div>
      </div>

      <!-- Close Button -->
      <div class="cross-arrow-pos">
        <span (click)="hideSendControlPopup()">
          <img src="./assets/images/otpCancel.svg" alt="Close" class="ms-xl-4" />
        </span>
      </div>
    </div>
  </div>
</div>